module.exports = {
  "context": {
    "checkIn": {
      "beginTime": "15:00+04:00",
      "endTime": "00:00+04:00",
      "instructions": "<ul>  <li>Extra-person charges may apply and vary depending on property policy</li><li>Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges</li><li>Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed</li><li>This property accepts credit cards, debit cards, and cash</li><li>This property reserves the right to pre-authorize the guest's credit card prior to arrival.</li><li>Cashless transactions are available</li><li>Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit</li><li>This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room</li>  </ul>",
      "minAge": 18,
      "specialInstructions": "This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools.",
      "startDate": "2026-12-13"
    },
    "checkOut": {
      "endDate": "2026-12-14",
      "time": "11:00+04:00"
    },
    "clientCredits": [],
    "exchangeRates": [
      {
        "from": "AED",
        "rate": 0.27226428356260673,
        "to": "USD"
      }
    ],
    "offerExpiration": "2026-07-08T13:42:16Z",
    "rooms": [
      {
        "adults": 2
      }
    ]
  },
  "hotel": {
    "address": {
      "addressLine1": "Yas Island",
      "cityName": "Abu Dhabi",
      "countryCode": "AE",
      "countryName": "United Arab Emirates",
      "postalCode": "",
      "provinceCode": "",
      "provinceName": ""
    },
    "amenities": [
      {
        "description": "Dry cleaning/laundry service",
        "id": "2070",
        "type": "dry_cleaning_laundry"
      },
      {
        "description": "Gift shops or newsstand",
        "id": "44"
      },
      {
        "description": "Outdoor entertainment area",
        "id": "1073744378"
      },
      {
        "description": "Pool umbrellas",
        "id": "2352"
      },
      {
        "description": "Number of meeting rooms - 5",
        "id": "2593",
        "value": "5"
      },
      {
        "description": "Conference space size (meters) - 394",
        "id": "2592",
        "value": "394"
      },
      {
        "description": "Free WiFi",
        "id": "2390",
        "type": "wifi"
      },
      {
        "description": "Number of bars/lounges - 2",
        "id": "3913",
        "value": "2"
      },
      {
        "description": "Number of poolside bars - 2",
        "id": "3914",
        "value": "2"
      },
      {
        "description": "Number of outdoor pools - 2",
        "id": "2821",
        "value": "2"
      },
      {
        "description": "Number of swim-up bars - 1",
        "id": "3916",
        "value": "1"
      },
      {
        "description": "Wheelchair-accessible lounge",
        "id": "1073744641"
      },
      {
        "description": "Wheelchair-accessible on-site restaurant",
        "id": "1073744640"
      },
      {
        "description": "Visual alarms in hallways",
        "id": "1073744642"
      },
      {
        "description": "Handrails in stairways",
        "id": "1073744645"
      },
      {
        "description": "Multilingual staff",
        "id": "2043"
      },
      {
        "description": "Wheelchairs available on site",
        "id": "1073744646"
      },
      {
        "description": "Breakfast available (surcharge)",
        "id": "361"
      },
      {
        "description": "Number of coffee shops/cafes - 1",
        "id": "3929",
        "value": "1"
      },
      {
        "description": "Children's club (free)",
        "id": "4697"
      },
      {
        "description": "Elevator",
        "id": "8"
      },
      {
        "description": "Secured parking",
        "id": "1073744274"
      },
      {
        "description": "Wheelchair accessible (may have limitations)",
        "id": "1073744430"
      },
      {
        "description": "Banquet hall",
        "id": "1073744111"
      },
      {
        "description": "Ballroom",
        "id": "1073744110"
      },
      {
        "description": "Wheelchair-accessible spa",
        "id": "1073744636"
      },
      {
        "description": "Wheelchair-accessible public washroom",
        "id": "1073744629"
      },
      {
        "description": "Spa treatment room(s)",
        "id": "2129",
        "type": "spa_services"
      },
      {
        "description": "Health club",
        "id": "2008",
        "type": "gym"
      },
      {
        "description": "Full-service spa",
        "id": "2123",
        "type": "spa_services"
      },
      {
        "description": "24-hour fitness facilities",
        "id": "4468",
        "type": "gym"
      },
      {
        "description": "Luggage storage",
        "id": "4003"
      },
      {
        "description": "Porter/bellhop",
        "id": "2066"
      },
      {
        "description": "Children's club",
        "id": "2186"
      },
      {
        "description": "24-hour front desk",
        "id": "2063"
      },
      {
        "description": "Lifeguard on site",
        "id": "1073744825"
      },
      {
        "description": "Playground on site",
        "id": "3825"
      },
      {
        "description": "Number of restaurants - 3",
        "id": "2537",
        "value": "3"
      },
      {
        "description": "Housekeeping on request",
        "id": "1073743926"
      },
      {
        "description": "Smoke-free property",
        "id": "2137"
      },
      {
        "description": "Safe-deposit box at front desk",
        "id": "2016"
      },
      {
        "description": "Children's pool",
        "id": "2014",
        "type": "swimming_pool"
      },
      {
        "description": "Free self parking",
        "id": "3861",
        "type": "parking"
      },
      {
        "description": "Conference space",
        "id": "81",
        "type": "meeting_facility"
      },
      {
        "description": "Hair salon",
        "id": "40"
      },
      {
        "description": "Pool sun loungers",
        "id": "4438"
      },
      {
        "description": "Access to nearby outdoor pool",
        "id": "3789",
        "type": "swimming_pool"
      },
      {
        "description": "Wheelchair accessible path of travel",
        "id": "2419",
        "type": "accessibility"
      },
      {
        "description": "ATM/banking",
        "id": "41"
      },
      {
        "description": "Conference space size (feet) - 4241",
        "id": "2539",
        "value": "4241"
      },
      {
        "description": "Concierge services",
        "id": "43"
      },
      {
        "description": "Service animals not allowed",
        "id": "2808"
      },
      {
        "description": "Pets not allowed",
        "id": "2050"
      }
    ],
    "brand": {
      "code": "3000",
      "name": "Curio Collection"
    },
    "caption": "Near Warner Bros. World Abu Dhabi",
    "chain": {
      "code": "HL",
      "name": "Hilton Worldwide",
      "validForLoyaltyProgram": true
    },
    "checkIn": {
      "beginTime": "15:00+04:00",
      "endTime": "00:00+04:00",
      "instructions": "<ul>  <li>Extra-person charges may apply and vary depending on property policy</li><li>Government-issued photo identification and a credit card, debit card, or cash deposit may be required at check-in for incidental charges</li><li>Special requests are subject to availability upon check-in and may incur additional charges; special requests cannot be guaranteed</li><li>This property accepts credit cards, debit cards, and cash</li><li>This property reserves the right to pre-authorize the guest's credit card prior to arrival.</li><li>Cashless transactions are available</li><li>Safety features at this property include a fire extinguisher, a smoke detector, and a first aid kit</li><li>This property has outdoor spaces, such as balconies, patios, terraces which may not be suitable for children; if you have concerns, we recommend contacting the property prior to your arrival to confirm they can accommodate you in a suitable room</li>  </ul>",
      "minAge": 18,
      "specialInstructions": "This property doesn't offer after-hours check-in. Front desk staff will greet guests on arrival at the property. Information provided by the property may be translated using automated translation tools.",
      "startDate": "2026-12-13"
    },
    "checkOut": {
      "endDate": "2026-12-14",
      "time": "11:00+04:00"
    },
    "clientHotelDecoration": {
      "clientHotelInfo": {
        "id": "ZHOT-EXPEDIA-71554879"
      },
      "programBenefits": [],
      "programs": [
        "LRG"
      ]
    },
    "description": "Pamper yourself with a visit to the spa, which offers massages, body treatments, and facials. You're sure to appreciate the recreational amenities, which include 2 outdoor pools and a health club. Additional amenities at this resort include complimentary wireless internet access, concierge services, and gift shops/newsstands.",
    "geoLocation": {
      "latitude": 24.489769,
      "longitude": 54.598516
    },
    "hostLanguages": "hi,de,ar,ru,af,el,fil,en,zh-cmn,it,fr,tr,nl",
    "id": "ZHOT-EXPEDIA-71554879",
    "images": [
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b4af6e67_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78a88f39_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5353e3f_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b9b5d57_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8be4744a_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ab540e11_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69d052c9_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d89aba7e_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f84c5401_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/997b2db7_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/925727f2_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dba882a9_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5186724c_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9378456e_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a143b0a3_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79533c01_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1b4f57b5_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/42d2b71e_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5050ee0_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/34348c30_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2897ebbc_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/903313ac_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3a85469_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4128904e_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/010d268f_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e01f4810_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e96fc7a2_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c54d67f4_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bc5beea4_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51743754_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4b9e3802_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f52f681c_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51aa5834_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4ebd8e10_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a656698_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/019367e3_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/efbc732a_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d06d78a7_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1494541e_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4187c0a3_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d8e83c67_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ad8ba36b_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5c6e8f1a_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71c3280c_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e293c708_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71208ca0_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd17fc11_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed5a1a8d_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e15cb6ff_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e70bf6e2_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/713bab71_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ace6d6b6_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/786bec5b_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a2821f48_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4d401fa1_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4db05e8b_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a73e4b74_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2fc3af_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78cd06a1_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fe0e9bee_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/94f7e7df_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/39a700e7_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/59719161_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/126d49d0_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f82a57c2_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0dfd54cd_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3fee3a0_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f94ab05e_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd66fa78_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ee473d7a_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/54ac3f16_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69013714_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8ad416d4_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcc8d19a_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0fe380a4_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/533bab9a_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8e0f3df8_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/28532e7f_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3fecab2a_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/602add40_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ea9af813_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b645174b_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9cc488d2_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d3708acb_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/64d5ee8b_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fb31e013_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6c7fe23_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/aad6a7cd_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c6819597_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d75edb8b_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17a1eeb2_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ceee18e2_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/383aa31e_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a6fbd540_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3624acad_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79184eef_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0102287f_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/99d9d50d_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/685c4c6c_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2c286c_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/de70bf85_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/362f24b1_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/06089eec_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/acd418f4_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ef5a3f87_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/afbedbe8_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/00d0841d_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c9b09824_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a1234cc3_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fd208875_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3479c99e_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b0e4c78_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/07d78029_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cc81a289_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d85f756c_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/077f403f_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b2646d32_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/22f10357_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed16dca2_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/eac0268b_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5778c2d_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/611372fb_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dadbf70a_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9d6b2d1d_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a4aeeb8_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/33983608_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bf92e3b4_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0b611d1f_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/41e136f3_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/53d75339_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8cea581e_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3ddb8e86_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f5f6e783_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d4f63454_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/337b04e0_z.jpg",
      "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ebf4823e_z.jpg"
    ],
    "interests": [
      "Business property",
      "Luxury property",
      "Spa",
      "Business",
      "Family property",
      "Eco-certified property",
      "City",
      "Spa property"
    ],
    "locationTeaser": "Located in Abu Dhabi, The WB Abu Dhabi, Curio Collection by Hilton is in the entertainment district, a 2-minute walk from Warner Bros. World Abu Dhabi and 7 minutes by foot from Yas Waterworld.  This family-friendly resort is 1.3 mi (2.1 km) from Yas Mall and 1.4 mi (2.2 km) from Yas Marina Circuit.",
    "name": "The WB Abu Dhabi, Curio Collection by Hilton",
    "noShowPolicy": "If you fail to check-in for this reservation, or if you cancel or change this reservation after the penalty period or check-in, you may incur penalty charges at the discretion of the property of up to 100% of the booking value.",
    "paymentOptions": [
      "Visa",
      "Diners Club",
      "Debit cards",
      "Cash",
      "American Express",
      "JCB International",
      "Mastercard"
    ],
    "phone": "971-02 208 6889",
    "policies": [
      {
        "description": "Pool access available from 8:00 AM to 11:00 PM."
      },
      {
        "description": "The property has connecting/adjoining rooms, which are subject to availability and can be requested by contacting the property using the number on the booking confirmation."
      },
      {
        "description": "No pets and no service animals are allowed at this property."
      },
      {
        "description": "Cashless payment methods are available for all transactions and guests can access their rooms with a mobile device."
      },
      {
        "description": "If you fail to check-in for this reservation, or if you cancel or change this reservation after the penalty period or check-in, you may incur penalty charges at the discretion of the property of up to 100% of the booking value."
      }
    ],
    "propertyImages": [
      {
        "caption": "Primary image",
        "isHero": true,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b4af6e67_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b4af6e67_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b4af6e67_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78a88f39_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78a88f39_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78a88f39_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5353e3f_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5353e3f_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5353e3f_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b9b5d57_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b9b5d57_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b9b5d57_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8be4744a_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8be4744a_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8be4744a_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ab540e11_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ab540e11_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ab540e11_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69d052c9_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69d052c9_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69d052c9_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d89aba7e_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d89aba7e_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d89aba7e_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f84c5401_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f84c5401_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f84c5401_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/997b2db7_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/997b2db7_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/997b2db7_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/925727f2_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/925727f2_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/925727f2_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dba882a9_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dba882a9_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dba882a9_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5186724c_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5186724c_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5186724c_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9378456e_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9378456e_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9378456e_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a143b0a3_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a143b0a3_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a143b0a3_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79533c01_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79533c01_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79533c01_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1b4f57b5_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1b4f57b5_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1b4f57b5_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/42d2b71e_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/42d2b71e_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/42d2b71e_t.jpg"
      },
      {
        "caption": "Lobby",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5050ee0_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5050ee0_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5050ee0_t.jpg"
      },
      {
        "caption": "Reception",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/34348c30_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/34348c30_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/34348c30_t.jpg"
      },
      {
        "caption": "Reception",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2897ebbc_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2897ebbc_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2897ebbc_t.jpg"
      },
      {
        "caption": "Lobby sitting area",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/903313ac_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/903313ac_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/903313ac_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3a85469_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3a85469_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3a85469_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4128904e_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4128904e_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4128904e_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/010d268f_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/010d268f_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/010d268f_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e01f4810_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e01f4810_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e01f4810_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e96fc7a2_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e96fc7a2_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e96fc7a2_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c54d67f4_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c54d67f4_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c54d67f4_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bc5beea4_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bc5beea4_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bc5beea4_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51743754_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51743754_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51743754_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4b9e3802_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4b9e3802_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4b9e3802_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f52f681c_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f52f681c_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f52f681c_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_t.jpg"
      },
      {
        "caption": "Room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51aa5834_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51aa5834_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51aa5834_t.jpg"
      },
      {
        "caption": "Private kitchen",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4ebd8e10_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4ebd8e10_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4ebd8e10_t.jpg"
      },
      {
        "caption": "Living area",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a656698_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a656698_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a656698_t.jpg"
      },
      {
        "caption": "Living area",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_t.jpg"
      },
      {
        "caption": "Living area",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/019367e3_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/019367e3_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/019367e3_t.jpg"
      },
      {
        "caption": "Living area",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/efbc732a_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/efbc732a_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/efbc732a_t.jpg"
      },
      {
        "caption": "Living area",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d06d78a7_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d06d78a7_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d06d78a7_t.jpg"
      },
      {
        "caption": "Living area",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_t.jpg"
      },
      {
        "caption": "Living area",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_t.jpg"
      },
      {
        "caption": "Living area",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1494541e_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1494541e_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1494541e_t.jpg"
      },
      {
        "caption": "Living area",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_t.jpg"
      },
      {
        "caption": "Living area",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_t.jpg"
      },
      {
        "caption": "View from room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4187c0a3_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4187c0a3_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4187c0a3_t.jpg"
      },
      {
        "caption": "View from room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_t.jpg"
      },
      {
        "caption": "View from room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_t.jpg"
      },
      {
        "caption": "View from room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d8e83c67_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d8e83c67_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d8e83c67_t.jpg"
      },
      {
        "caption": "View from room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_t.jpg"
      },
      {
        "caption": "View from room",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_t.jpg"
      },
      {
        "caption": "Bathroom",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ad8ba36b_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ad8ba36b_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ad8ba36b_t.jpg"
      },
      {
        "caption": "Bathroom",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_t.jpg"
      },
      {
        "caption": "Bathroom shower",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_t.jpg"
      },
      {
        "caption": "Bathroom shower",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_t.jpg"
      },
      {
        "caption": "Bathroom shower",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
      },
      {
        "caption": "Pool",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5c6e8f1a_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5c6e8f1a_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5c6e8f1a_t.jpg"
      },
      {
        "caption": "Pool",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71c3280c_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71c3280c_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71c3280c_t.jpg"
      },
      {
        "caption": "Pool",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e293c708_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e293c708_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e293c708_t.jpg"
      },
      {
        "caption": "Pool",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71208ca0_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71208ca0_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/71208ca0_t.jpg"
      },
      {
        "caption": "Outdoor pool",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd17fc11_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd17fc11_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd17fc11_t.jpg"
      },
      {
        "caption": "Outdoor pool",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed5a1a8d_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed5a1a8d_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed5a1a8d_t.jpg"
      },
      {
        "caption": "Rooftop pool",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e15cb6ff_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e15cb6ff_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e15cb6ff_t.jpg"
      },
      {
        "caption": "Rooftop pool",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e70bf6e2_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e70bf6e2_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e70bf6e2_t.jpg"
      },
      {
        "caption": "Swim-up bar",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/713bab71_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/713bab71_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/713bab71_t.jpg"
      },
      {
        "caption": "Fitness facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ace6d6b6_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ace6d6b6_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ace6d6b6_t.jpg"
      },
      {
        "caption": "Fitness facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/786bec5b_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/786bec5b_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/786bec5b_t.jpg"
      },
      {
        "caption": "Fitness studio",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a2821f48_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a2821f48_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a2821f48_t.jpg"
      },
      {
        "caption": "Spa",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4d401fa1_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4d401fa1_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4d401fa1_t.jpg"
      },
      {
        "caption": "Spa",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4db05e8b_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4db05e8b_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4db05e8b_t.jpg"
      },
      {
        "caption": "Spa",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a73e4b74_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a73e4b74_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a73e4b74_t.jpg"
      },
      {
        "caption": "Spa",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2fc3af_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2fc3af_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2fc3af_t.jpg"
      },
      {
        "caption": "Spa",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78cd06a1_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78cd06a1_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/78cd06a1_t.jpg"
      },
      {
        "caption": "Spa",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fe0e9bee_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fe0e9bee_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fe0e9bee_t.jpg"
      },
      {
        "caption": "Spa",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/94f7e7df_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/94f7e7df_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/94f7e7df_t.jpg"
      },
      {
        "caption": "Spa treatment",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/39a700e7_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/39a700e7_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/39a700e7_t.jpg"
      },
      {
        "caption": "Property amenity",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/59719161_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/59719161_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/59719161_t.jpg"
      },
      {
        "caption": "Property amenity",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/126d49d0_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/126d49d0_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/126d49d0_t.jpg"
      },
      {
        "caption": "Property amenity",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f82a57c2_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f82a57c2_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f82a57c2_t.jpg"
      },
      {
        "caption": "Property amenity",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0dfd54cd_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0dfd54cd_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0dfd54cd_t.jpg"
      },
      {
        "caption": "Gift shop",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3fee3a0_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3fee3a0_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3fee3a0_t.jpg"
      },
      {
        "caption": "Gift shop",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f94ab05e_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f94ab05e_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f94ab05e_t.jpg"
      },
      {
        "caption": "Children's play area - indoor",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd66fa78_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd66fa78_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bd66fa78_t.jpg"
      },
      {
        "caption": "Children's activities",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ee473d7a_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ee473d7a_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ee473d7a_t.jpg"
      },
      {
        "caption": "Children's activities",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/54ac3f16_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/54ac3f16_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/54ac3f16_t.jpg"
      },
      {
        "caption": "Children's activities",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69013714_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69013714_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/69013714_t.jpg"
      },
      {
        "caption": "Children's activities",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8ad416d4_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8ad416d4_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8ad416d4_t.jpg"
      },
      {
        "caption": "Children's activities",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcc8d19a_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcc8d19a_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcc8d19a_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0fe380a4_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0fe380a4_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0fe380a4_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/533bab9a_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/533bab9a_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/533bab9a_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8e0f3df8_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8e0f3df8_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8e0f3df8_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/28532e7f_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/28532e7f_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/28532e7f_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3fecab2a_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3fecab2a_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3fecab2a_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/602add40_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/602add40_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/602add40_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ea9af813_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ea9af813_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ea9af813_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b645174b_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b645174b_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b645174b_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9cc488d2_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9cc488d2_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9cc488d2_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d3708acb_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d3708acb_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d3708acb_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/64d5ee8b_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/64d5ee8b_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/64d5ee8b_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fb31e013_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fb31e013_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fb31e013_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6c7fe23_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6c7fe23_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6c7fe23_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/aad6a7cd_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/aad6a7cd_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/aad6a7cd_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c6819597_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c6819597_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c6819597_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d75edb8b_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d75edb8b_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d75edb8b_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17a1eeb2_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17a1eeb2_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17a1eeb2_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ceee18e2_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ceee18e2_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ceee18e2_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/383aa31e_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/383aa31e_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/383aa31e_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a6fbd540_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a6fbd540_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a6fbd540_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3624acad_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3624acad_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3624acad_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79184eef_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79184eef_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/79184eef_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0102287f_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0102287f_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0102287f_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/99d9d50d_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/99d9d50d_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/99d9d50d_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/685c4c6c_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/685c4c6c_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/685c4c6c_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2c286c_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2c286c_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dc2c286c_t.jpg"
      },
      {
        "caption": "Restaurant",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/de70bf85_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/de70bf85_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/de70bf85_t.jpg"
      },
      {
        "caption": "Breakfast buffet",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/362f24b1_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/362f24b1_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/362f24b1_t.jpg"
      },
      {
        "caption": "Bar (on property)",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/06089eec_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/06089eec_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/06089eec_t.jpg"
      },
      {
        "caption": "Bar (on property)",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/acd418f4_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/acd418f4_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/acd418f4_t.jpg"
      },
      {
        "caption": "Ballroom",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ef5a3f87_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ef5a3f87_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ef5a3f87_t.jpg"
      },
      {
        "caption": "Ballroom",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/afbedbe8_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/afbedbe8_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/afbedbe8_t.jpg"
      },
      {
        "caption": "Ballroom",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/00d0841d_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/00d0841d_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/00d0841d_t.jpg"
      },
      {
        "caption": "Ballroom",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c9b09824_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c9b09824_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c9b09824_t.jpg"
      },
      {
        "caption": "Ballroom",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a1234cc3_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a1234cc3_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a1234cc3_t.jpg"
      },
      {
        "caption": "Ballroom",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fd208875_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fd208875_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fd208875_t.jpg"
      },
      {
        "caption": "Ballroom",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3479c99e_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3479c99e_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3479c99e_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b0e4c78_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b0e4c78_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/5b0e4c78_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/07d78029_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/07d78029_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/07d78029_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cc81a289_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cc81a289_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cc81a289_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d85f756c_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d85f756c_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d85f756c_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/077f403f_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/077f403f_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/077f403f_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b2646d32_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b2646d32_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b2646d32_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/22f10357_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/22f10357_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/22f10357_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed16dca2_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed16dca2_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ed16dca2_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/eac0268b_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/eac0268b_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/eac0268b_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5778c2d_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5778c2d_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b5778c2d_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/611372fb_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/611372fb_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/611372fb_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dadbf70a_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dadbf70a_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dadbf70a_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9d6b2d1d_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9d6b2d1d_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/9d6b2d1d_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a4aeeb8_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a4aeeb8_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/6a4aeeb8_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/33983608_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/33983608_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/33983608_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bf92e3b4_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bf92e3b4_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bf92e3b4_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0b611d1f_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0b611d1f_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0b611d1f_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/41e136f3_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/41e136f3_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/41e136f3_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/53d75339_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/53d75339_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/53d75339_t.jpg"
      },
      {
        "caption": "Meeting facility",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8cea581e_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8cea581e_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8cea581e_t.jpg"
      },
      {
        "caption": "Fountain",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3ddb8e86_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3ddb8e86_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3ddb8e86_t.jpg"
      },
      {
        "caption": "Exterior",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f5f6e783_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f5f6e783_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/f5f6e783_t.jpg"
      },
      {
        "caption": "Exterior",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d4f63454_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d4f63454_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d4f63454_t.jpg"
      },
      {
        "caption": "Exterior",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/337b04e0_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/337b04e0_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/337b04e0_t.jpg"
      },
      {
        "caption": "Exterior",
        "isHero": false,
        "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ebf4823e_z.jpg",
        "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ebf4823e_b.jpg",
        "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/ebf4823e_t.jpg"
      }
    ],
    "rank": 0,
    "roomTypes": [
      {
        "amenities": [
          {
            "description": "Soap",
            "id": "1073744201"
          },
          {
            "description": "Mobile key entry",
            "id": "1073744900"
          },
          {
            "description": "Private bathroom",
            "id": "141"
          },
          {
            "description": "Slippers",
            "id": "2162"
          },
          {
            "description": "Free cribs/infant beds",
            "id": "4951",
            "type": "crib"
          },
          {
            "description": "Visual fire alarm",
            "id": "1073744686"
          },
          {
            "description": "Espresso maker",
            "id": "399"
          },
          {
            "description": "Satellite TV service",
            "id": "2396"
          },
          {
            "description": "Coffee/tea maker",
            "id": "132"
          },
          {
            "description": "Non-Smoking",
            "id": "6176"
          },
          {
            "description": "Television",
            "id": "26"
          },
          {
            "description": "Bidet",
            "id": "2149"
          },
          {
            "description": "Rollaway/extra beds (surcharge)",
            "id": "1073742816"
          },
          {
            "description": "Bedsheets provided",
            "id": "1073743371"
          },
          {
            "description": "Low-height counters/sink",
            "id": "1073744667"
          },
          {
            "description": "Laptop-friendly workspace",
            "id": "1073744237"
          },
          {
            "description": "WiFi speed - 100+ Mbps (good for 1–2 people or up to 6 devices)",
            "id": "1073745175",
            "value": "100+ Mbps (good for 1–2 people or up to 6 devices)"
          },
          {
            "description": "Blackout drapes/curtains",
            "id": "2150"
          },
          {
            "description": "Electric kettle",
            "id": "1073743289"
          },
          {
            "description": "Connecting/adjoining rooms available",
            "id": "4420"
          },
          {
            "description": "Desk chair",
            "id": "1073745166"
          },
          {
            "description": "Phone",
            "id": "136"
          },
          {
            "description": "Minibar",
            "id": "131"
          },
          {
            "description": "LED TV",
            "id": "6147"
          },
          {
            "description": "Free toiletries",
            "id": "143"
          },
          {
            "description": "Smooth flooring in room",
            "id": "1073745362"
          },
          {
            "description": "Wireless internet access",
            "id": "2100"
          },
          {
            "description": "TV size: 55",
            "id": "2579",
            "value": "55"
          },
          {
            "description": "Shampoo",
            "id": "1073744202"
          },
          {
            "description": "Hand-held showerhead",
            "id": "1073744651"
          },
          {
            "description": "Room service (24 hours)",
            "id": "2015"
          },
          {
            "description": "Free bottled water",
            "id": "2057"
          },
          {
            "description": "Towels provided",
            "id": "1073743370"
          },
          {
            "description": "Air conditioning",
            "id": "1",
            "type": "air_conditioning"
          },
          {
            "description": "Grab bar - near toilet",
            "id": "1073744675"
          },
          {
            "description": "Shower/tub combination",
            "id": "2183"
          },
          {
            "description": "Wardrobe or closet",
            "id": "1073744706"
          },
          {
            "description": "Bathroom emergency pull cord",
            "id": "1073744681"
          },
          {
            "description": "Desk",
            "id": "2026"
          },
          {
            "description": "Soundproofed rooms",
            "id": "2054"
          },
          {
            "description": "Toilet paper",
            "id": "1073744203"
          },
          {
            "description": "Free WiFi",
            "id": "2403",
            "type": "free_wifi"
          },
          {
            "description": "Bathrobes",
            "id": "142"
          },
          {
            "description": "Hair dryer",
            "id": "144"
          },
          {
            "description": "Rainfall showerhead",
            "id": "3502"
          },
          {
            "description": "Daily housekeeping",
            "id": "133"
          },
          {
            "description": "Housekeeping on request",
            "id": "1073743926"
          },
          {
            "description": "In-room safe",
            "id": "146"
          },
          {
            "description": "Iron/ironing board",
            "id": "145"
          },
          {
            "description": "TV size measurement: inch",
            "id": "2580",
            "value": "inch"
          }
        ],
        "description": "<p><strong>2 Double Beds</strong></p><p>Soundproofed room</p><br/><p><b>Internet</b> - Free WiFi 100+ Mbps (good for 1–2 people or up to 6 devices) </p><p><b>Entertainment</b> - 55-inch LED TV with satellite channels</p><p><b>Food & Drink</b> - Espresso maker, minibar (fees may apply), electric kettle, and 24-hour room service</p><p><b>Sleep</b> - Blackout drapes/curtains and bed sheets </p><p><b>Bathroom</b> - Private bathroom, bathrobes, and a shower/tub combination with a rainfall showerhead</p><p><b>Practical</b> - Safe, iron/ironing board, and laptop workspace; rollaway beds (surcharge) and cribs (free) available on request</p><p><b>Comfort</b> - Air conditioning and daily housekeeping</p><p><b>Accessibility</b> - Hand-held showerhead</p><p><b>Need to Know</b> - Housekeeping on request</p><p>Non-Smoking</p><p>Connecting/adjoining rooms can be requested, subject to availability </p>",
        "id": "315639054",
        "images": [
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
        ],
        "maxOccupancy": 3,
        "name": "Room, 2 Double Beds (Theme Park Access)",
        "propertyImages": [
          {
            "caption": "Living area",
            "isHero": true,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c8ddaea4_t.jpg"
          },
          {
            "caption": "Bathroom shower",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
          }
        ],
        "rates": [
          {
            "amenities": [
              {
                "description": "Free WiFi",
                "id": "2192"
              },
              {
                "description": "Free self parking",
                "id": "2109"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 2,
                    "type": "FullBed"
                  }
                ],
                "bookToken": "hotel-expedia_2a0c12c581db4d1481c11ae49b748642_1783518136",
                "description": "2 Double Beds",
                "id": "37365"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "USD",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308366",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 408.7,
              "averageNightlyRatePointsBurn": 58386,
              "averageNightlyRateStrikethrough": 480.82,
              "base": 408.7,
              "baseStrikethrough": 480.82,
              "currency": "USD",
              "fees": [
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "PROPERTY_FEE",
                  "value": 40.87
                },
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 55.17
                }
              ],
              "nightlyActualRates": [
                408.7
              ],
              "nightlyInclusiveRates": [
                463.87
              ],
              "paymentModel": "PAY_NOW",
              "pointsBurn": 72106,
              "pointsBurnCalculation": {
                "code": "OMHZ",
                "maximumLimit": 2147483647,
                "minimumLimit": 1,
                "scope": "DEFAULT",
                "type": "RATE",
                "value": 0.007
              },
              "strikethroughWithFees": 576.86,
              "taxes": [],
              "total": 504.74,
              "totalFees": 96.04,
              "totalInclusive": 504.74,
              "totalStrikeThrough": 576.86,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "USD",
                      "value": 463.87
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 408.7,
                  "averageNightlyRatePointsBurn": 58386,
                  "averageNightlyRateStrikethrough": 480.82,
                  "base": 408.7,
                  "baseStrikethrough": 480.82,
                  "currency": "USD",
                  "fees": [
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "PROPERTY_FEE",
                      "value": 40.87
                    },
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 55.17
                    }
                  ],
                  "nightlyActualRates": [
                    408.7
                  ],
                  "nightlyInclusiveRates": [
                    463.87
                  ],
                  "paymentModel": "PAY_NOW",
                  "pointsBurn": 72106,
                  "pointsBurnCalculation": {
                    "code": "OMHZ",
                    "maximumLimit": 2147483647,
                    "minimumLimit": 1,
                    "scope": "DEFAULT",
                    "type": "RATE",
                    "value": 0.007
                  },
                  "strikethroughWithFees": 576.86,
                  "taxes": [],
                  "total": 504.74,
                  "totalFees": 96.04,
                  "totalInclusive": 504.74,
                  "totalStrikeThrough": 576.86,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          },
          {
            "amenities": [
              {
                "description": "Free WiFi",
                "id": "2192"
              },
              {
                "description": "Free self parking",
                "id": "2109"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 2,
                    "type": "FullBed"
                  }
                ],
                "bookToken": "hotel-expedia_839195bf25da48bc8ad9a090eeaad9f6_1783518136",
                "description": "2 Double Beds",
                "id": "37365"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "AED",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308366",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 1501.1,
              "averageNightlyRateStrikethrough": 1766,
              "base": 1501.1,
              "baseStrikethrough": 1766,
              "currency": "AED",
              "fees": [
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "PROPERTY_FEE",
                  "value": 150.11
                },
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 202.65
                }
              ],
              "nightlyActualRates": [
                1501.1
              ],
              "nightlyInclusiveRates": [
                1703.75
              ],
              "paymentModel": "PAY_LATER",
              "strikethroughWithFees": 2118.76,
              "taxes": [],
              "total": 1853.86,
              "totalFees": 352.76,
              "totalInclusive": 1853.86,
              "totalStrikeThrough": 2118.76,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "AED",
                      "value": 1703.75
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 1501.1,
                  "averageNightlyRateStrikethrough": 1766,
                  "base": 1501.1,
                  "baseStrikethrough": 1766,
                  "currency": "AED",
                  "fees": [
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "PROPERTY_FEE",
                      "value": 150.11
                    },
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 202.65
                    }
                  ],
                  "nightlyActualRates": [
                    1501.1
                  ],
                  "nightlyInclusiveRates": [
                    1703.75
                  ],
                  "paymentModel": "PAY_LATER",
                  "strikethroughWithFees": 2118.76,
                  "taxes": [],
                  "total": 1853.86,
                  "totalFees": 352.76,
                  "totalInclusive": 1853.86,
                  "totalStrikeThrough": 2118.76,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          }
        ]
      },
      {
        "amenities": [
          {
            "description": "Free WiFi",
            "id": "2403",
            "type": "free_wifi"
          },
          {
            "description": "Rainfall showerhead",
            "id": "3502"
          },
          {
            "description": "Connecting/adjoining rooms available",
            "id": "4420"
          },
          {
            "description": "Free cribs/infant beds",
            "id": "4951",
            "type": "crib"
          },
          {
            "description": "Television",
            "id": "26"
          },
          {
            "description": "Satellite TV service",
            "id": "2396"
          },
          {
            "description": "Rollaway/extra beds (surcharge)",
            "id": "1073742816"
          },
          {
            "description": "Wheelchair-width doorways",
            "id": "1073744690"
          },
          {
            "description": "WiFi speed - 100+ Mbps (good for 1–2 people or up to 6 devices)",
            "id": "1073745175",
            "value": "100+ Mbps (good for 1–2 people or up to 6 devices)"
          },
          {
            "description": "Smooth flooring in room",
            "id": "1073745362"
          },
          {
            "description": "Coffee/tea maker",
            "id": "132"
          },
          {
            "description": "Bathrobes",
            "id": "142"
          },
          {
            "description": "Free toiletries",
            "id": "143"
          },
          {
            "description": "TV size: 55",
            "id": "2579",
            "value": "55"
          },
          {
            "description": "Wheelchair accessible",
            "id": "121",
            "type": "accessible_wheelchair"
          },
          {
            "description": "TV size measurement: inch",
            "id": "2580",
            "value": "inch"
          },
          {
            "description": "Iron/ironing board",
            "id": "145"
          },
          {
            "description": "In-room safe",
            "id": "146"
          },
          {
            "description": "Electric kettle",
            "id": "1073743289"
          },
          {
            "description": "Bathroom emergency pull cord",
            "id": "1073744681"
          },
          {
            "description": "Soundproofed rooms",
            "id": "2054"
          },
          {
            "description": "Towels provided",
            "id": "1073743370"
          },
          {
            "description": "Bedsheets provided",
            "id": "1073743371"
          },
          {
            "description": "Wireless internet access",
            "id": "2100"
          },
          {
            "description": "Non-Smoking",
            "id": "6176"
          },
          {
            "description": "Slippers",
            "id": "2162"
          },
          {
            "description": "Phone",
            "id": "136"
          },
          {
            "description": "Hair dryer",
            "id": "144"
          },
          {
            "description": "Minibar",
            "id": "131"
          },
          {
            "description": "LED TV",
            "id": "6147"
          },
          {
            "description": "Espresso maker",
            "id": "399"
          },
          {
            "description": "Wardrobe or closet",
            "id": "1073744706"
          },
          {
            "description": "Desk chair",
            "id": "1073745166"
          },
          {
            "description": "Blackout drapes/curtains",
            "id": "2150"
          },
          {
            "description": "Private bathroom",
            "id": "141"
          },
          {
            "description": "Shower/tub combination",
            "id": "2183"
          },
          {
            "description": "Grab bar - in shower",
            "id": "1073744679"
          },
          {
            "description": "Soap",
            "id": "1073744201"
          },
          {
            "description": "Daily housekeeping",
            "id": "133"
          },
          {
            "description": "Bidet",
            "id": "2149"
          },
          {
            "description": "Toilet paper",
            "id": "1073744203"
          },
          {
            "description": "Air conditioning",
            "id": "1",
            "type": "air_conditioning"
          },
          {
            "description": "Laptop-friendly workspace",
            "id": "1073744237"
          },
          {
            "description": "Room service (24 hours)",
            "id": "2015"
          },
          {
            "description": "Free bottled water",
            "id": "2057"
          },
          {
            "description": "Housekeeping on request",
            "id": "1073743926"
          },
          {
            "description": "Visual fire alarm",
            "id": "1073744686"
          },
          {
            "description": "Mobile key entry",
            "id": "1073744900"
          },
          {
            "description": "Hand-held showerhead",
            "id": "1073744651"
          },
          {
            "description": "Shampoo",
            "id": "1073744202"
          },
          {
            "description": "Grab bar - near toilet",
            "id": "1073744675"
          },
          {
            "description": "Low-height counters/sink",
            "id": "1073744667"
          },
          {
            "description": "Desk",
            "id": "2026"
          }
        ],
        "area": {
          "squareFeet": 377,
          "squareMeters": 35
        },
        "description": "<p><strong>1 King Bed</strong></p><p>377 sq feet </p><br/><p><b>Internet</b> - Free WiFi 100+ Mbps (good for 1–2 people or up to 6 devices) </p><p><b>Entertainment</b> - 55-inch LED TV with satellite channels</p><p><b>Food & Drink</b> - Espresso maker, minibar (fees may apply), electric kettle, and 24-hour room service</p><p><b>Sleep</b> - Blackout drapes/curtains and bed sheets </p><p><b>Bathroom</b> - Private bathroom, bathrobes, and a shower/tub combination with a rainfall showerhead</p><p><b>Practical</b> - Safe, iron/ironing board, and laptop workspace; rollaway beds (surcharge) and cribs (free) available on request</p><p><b>Comfort</b> - Air conditioning and daily housekeeping</p><p><b>Accessibility</b> - Visual fire alarm</p><p><b>Need to Know</b> - Housekeeping on request</p><p>Non-Smoking</p><p>Connecting/adjoining rooms can be requested, subject to availability </p>",
        "id": "315639076",
        "images": [
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
        ],
        "maxOccupancy": 2,
        "name": "Room, 1 King Bed, Accessible (Theme Park Access)",
        "propertyImages": [
          {
            "caption": "Room",
            "isHero": true,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e4e97248_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c072a69f_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/7916905f_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/2a07f738_t.jpg"
          },
          {
            "caption": "Bathroom shower",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
          }
        ],
        "rates": [
          {
            "amenities": [
              {
                "description": "Free WiFi",
                "id": "2192"
              },
              {
                "description": "Free self parking",
                "id": "2109"
              }
            ],
            "available": 4,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 1,
                    "type": "KingBed"
                  }
                ],
                "bookToken": "hotel-expedia_f28caf62a3df4674bb4056cf1d28ba60_1783518136",
                "description": "1 King Bed",
                "id": "37321"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "USD",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308372",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 431.83,
              "averageNightlyRatePointsBurn": 61690,
              "averageNightlyRateStrikethrough": 508.04,
              "base": 431.83,
              "baseStrikethrough": 508.04,
              "currency": "USD",
              "fees": [
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "PROPERTY_FEE",
                  "value": 43.18
                },
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 58.29
                }
              ],
              "nightlyActualRates": [
                431.83
              ],
              "nightlyInclusiveRates": [
                490.12
              ],
              "paymentModel": "PAY_NOW",
              "pointsBurn": 76186,
              "pointsBurnCalculation": {
                "code": "OMHZ",
                "maximumLimit": 2147483647,
                "minimumLimit": 1,
                "scope": "DEFAULT",
                "type": "RATE",
                "value": 0.007
              },
              "strikethroughWithFees": 609.51,
              "taxes": [],
              "total": 533.3,
              "totalFees": 101.47,
              "totalInclusive": 533.3,
              "totalStrikeThrough": 609.51,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "USD",
                      "value": 490.12
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 431.83,
                  "averageNightlyRatePointsBurn": 61690,
                  "averageNightlyRateStrikethrough": 508.04,
                  "base": 431.83,
                  "baseStrikethrough": 508.04,
                  "currency": "USD",
                  "fees": [
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "PROPERTY_FEE",
                      "value": 43.18
                    },
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 58.29
                    }
                  ],
                  "nightlyActualRates": [
                    431.83
                  ],
                  "nightlyInclusiveRates": [
                    490.12
                  ],
                  "paymentModel": "PAY_NOW",
                  "pointsBurn": 76186,
                  "pointsBurnCalculation": {
                    "code": "OMHZ",
                    "maximumLimit": 2147483647,
                    "minimumLimit": 1,
                    "scope": "DEFAULT",
                    "type": "RATE",
                    "value": 0.007
                  },
                  "strikethroughWithFees": 609.51,
                  "taxes": [],
                  "total": 533.3,
                  "totalFees": 101.47,
                  "totalInclusive": 533.3,
                  "totalStrikeThrough": 609.51,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          },
          {
            "amenities": [
              {
                "description": "Free self parking",
                "id": "2109"
              },
              {
                "description": "Free WiFi",
                "id": "2192"
              }
            ],
            "available": 4,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 1,
                    "type": "KingBed"
                  }
                ],
                "bookToken": "hotel-expedia_178f7da4ea60409a86d129476489be32_1783518136",
                "description": "1 King Bed",
                "id": "37321"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "AED",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308372",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 1586.1,
              "averageNightlyRateStrikethrough": 1866,
              "base": 1586.1,
              "baseStrikethrough": 1866,
              "currency": "AED",
              "fees": [
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "PROPERTY_FEE",
                  "value": 158.61
                },
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 214.12
                }
              ],
              "nightlyActualRates": [
                1586.1
              ],
              "nightlyInclusiveRates": [
                1800.22
              ],
              "paymentModel": "PAY_LATER",
              "strikethroughWithFees": 2238.73,
              "taxes": [],
              "total": 1958.83,
              "totalFees": 372.73,
              "totalInclusive": 1958.83,
              "totalStrikeThrough": 2238.73,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "AED",
                      "value": 1800.22
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 1586.1,
                  "averageNightlyRateStrikethrough": 1866,
                  "base": 1586.1,
                  "baseStrikethrough": 1866,
                  "currency": "AED",
                  "fees": [
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "PROPERTY_FEE",
                      "value": 158.61
                    },
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 214.12
                    }
                  ],
                  "nightlyActualRates": [
                    1586.1
                  ],
                  "nightlyInclusiveRates": [
                    1800.22
                  ],
                  "paymentModel": "PAY_LATER",
                  "strikethroughWithFees": 2238.73,
                  "taxes": [],
                  "total": 1958.83,
                  "totalFees": 372.73,
                  "totalInclusive": 1958.83,
                  "totalStrikeThrough": 2238.73,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          }
        ]
      },
      {
        "amenities": [
          {
            "description": "Coffee/tea maker",
            "id": "132"
          },
          {
            "description": "Low-height counters/sink",
            "id": "1073744667"
          },
          {
            "description": "TV size measurement: inch",
            "id": "2580",
            "value": "inch"
          },
          {
            "description": "WiFi speed - 100+ Mbps (good for 1–2 people or up to 6 devices)",
            "id": "1073745175",
            "value": "100+ Mbps (good for 1–2 people or up to 6 devices)"
          },
          {
            "description": "Hand-held showerhead",
            "id": "1073744651"
          },
          {
            "description": "Rollaway/extra beds (surcharge)",
            "id": "1073742816"
          },
          {
            "description": "Private bathroom",
            "id": "141"
          },
          {
            "description": "Smooth flooring in room",
            "id": "1073745362"
          },
          {
            "description": "Free toiletries",
            "id": "143"
          },
          {
            "description": "Bidet",
            "id": "2149"
          },
          {
            "description": "Slippers",
            "id": "2162"
          },
          {
            "description": "Desk chair",
            "id": "1073745166"
          },
          {
            "description": "Air conditioning",
            "id": "1",
            "type": "air_conditioning"
          },
          {
            "description": "Rainfall showerhead",
            "id": "3502"
          },
          {
            "description": "Room service (24 hours)",
            "id": "2015"
          },
          {
            "description": "Grab bar - near toilet",
            "id": "1073744675"
          },
          {
            "description": "In-room safe",
            "id": "146"
          },
          {
            "description": "Laptop-friendly workspace",
            "id": "1073744237"
          },
          {
            "description": "Satellite TV service",
            "id": "2396"
          },
          {
            "description": "Daily housekeeping",
            "id": "133"
          },
          {
            "description": "Mobile key entry",
            "id": "1073744900"
          },
          {
            "description": "TV size: 55",
            "id": "2579",
            "value": "55"
          },
          {
            "description": "Desk",
            "id": "2026"
          },
          {
            "description": "Soundproofed rooms",
            "id": "2054"
          },
          {
            "description": "Free WiFi",
            "id": "2403",
            "type": "free_wifi"
          },
          {
            "description": "Toilet paper",
            "id": "1073744203"
          },
          {
            "description": "Bathroom emergency pull cord",
            "id": "1073744681"
          },
          {
            "description": "Wardrobe or closet",
            "id": "1073744706"
          },
          {
            "description": "Phone",
            "id": "136"
          },
          {
            "description": "Wireless internet access",
            "id": "2100"
          },
          {
            "description": "Towels provided",
            "id": "1073743370"
          },
          {
            "description": "Shower/tub combination",
            "id": "2183"
          },
          {
            "description": "Shampoo",
            "id": "1073744202"
          },
          {
            "description": "Visual fire alarm",
            "id": "1073744686"
          },
          {
            "description": "Non-Smoking",
            "id": "6176"
          },
          {
            "description": "Bathrobes",
            "id": "142"
          },
          {
            "description": "Hair dryer",
            "id": "144"
          },
          {
            "description": "LED TV",
            "id": "6147"
          },
          {
            "description": "Iron/ironing board",
            "id": "145"
          },
          {
            "description": "Television",
            "id": "26"
          },
          {
            "description": "Soap",
            "id": "1073744201"
          },
          {
            "description": "Connecting/adjoining rooms available",
            "id": "4420"
          },
          {
            "description": "Bedsheets provided",
            "id": "1073743371"
          },
          {
            "description": "Free bottled water",
            "id": "2057"
          },
          {
            "description": "Electric kettle",
            "id": "1073743289"
          },
          {
            "description": "Blackout drapes/curtains",
            "id": "2150"
          },
          {
            "description": "Minibar",
            "id": "131"
          },
          {
            "description": "Housekeeping on request",
            "id": "1073743926"
          },
          {
            "description": "Free cribs/infant beds",
            "id": "4951",
            "type": "crib"
          },
          {
            "description": "Espresso maker",
            "id": "399"
          }
        ],
        "area": {
          "squareFeet": 377,
          "squareMeters": 35
        },
        "description": "<p><strong>1 King Bed</strong></p><p>377 sq feet </p><br/><p><b>Internet</b> - Free WiFi 100+ Mbps (good for 1–2 people or up to 6 devices) </p><p><b>Entertainment</b> - 55-inch LED TV with satellite channels</p><p><b>Food & Drink</b> - Espresso maker, minibar (fees may apply), electric kettle, and 24-hour room service</p><p><b>Sleep</b> - Blackout drapes/curtains and bed sheets </p><p><b>Bathroom</b> - Private bathroom, bathrobes, and a shower/tub combination with a rainfall showerhead</p><p><b>Practical</b> - Safe, iron/ironing board, and laptop workspace; rollaway beds (surcharge) and cribs (free) available on request</p><p><b>Comfort</b> - Air conditioning and daily housekeeping</p><p><b>Accessibility</b> - Hand-held showerhead</p><p><b>Need to Know</b> - Housekeeping on request</p><p>Non-Smoking</p><p>Connecting/adjoining rooms can be requested, subject to availability </p>",
        "id": "315639068",
        "images": [
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51743754_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51aa5834_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1494541e_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
        ],
        "maxOccupancy": 4,
        "name": "Room, 1 King Bed (Theme Park Access)",
        "propertyImages": [
          {
            "caption": "Living area",
            "isHero": true,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51743754_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51743754_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51743754_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51743754_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51aa5834_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51aa5834_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51aa5834_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51aa5834_t.jpg"
          },
          {
            "caption": "Living area",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1494541e_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1494541e_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1494541e_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/1494541e_t.jpg"
          },
          {
            "caption": "Bathroom shower",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
          }
        ],
        "rates": [
          {
            "amenities": [
              {
                "description": "Free WiFi",
                "id": "2192"
              },
              {
                "description": "Free self parking",
                "id": "2109"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 1,
                    "type": "KingBed"
                  }
                ],
                "bookToken": "hotel-expedia_98c249fe79304c6fafe90df4a5ab6514_1783518136",
                "description": "1 King Bed",
                "id": "37321"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "USD",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308369",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 431.83,
              "averageNightlyRatePointsBurn": 61690,
              "averageNightlyRateStrikethrough": 508.04,
              "base": 431.83,
              "baseStrikethrough": 508.04,
              "currency": "USD",
              "fees": [
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "PROPERTY_FEE",
                  "value": 43.18
                },
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 58.29
                }
              ],
              "nightlyActualRates": [
                431.83
              ],
              "nightlyInclusiveRates": [
                490.12
              ],
              "paymentModel": "PAY_NOW",
              "pointsBurn": 76186,
              "pointsBurnCalculation": {
                "code": "OMHZ",
                "maximumLimit": 2147483647,
                "minimumLimit": 1,
                "scope": "DEFAULT",
                "type": "RATE",
                "value": 0.007
              },
              "strikethroughWithFees": 609.51,
              "taxes": [],
              "total": 533.3,
              "totalFees": 101.47,
              "totalInclusive": 533.3,
              "totalStrikeThrough": 609.51,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "USD",
                      "value": 490.12
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 431.83,
                  "averageNightlyRatePointsBurn": 61690,
                  "averageNightlyRateStrikethrough": 508.04,
                  "base": 431.83,
                  "baseStrikethrough": 508.04,
                  "currency": "USD",
                  "fees": [
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "PROPERTY_FEE",
                      "value": 43.18
                    },
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 58.29
                    }
                  ],
                  "nightlyActualRates": [
                    431.83
                  ],
                  "nightlyInclusiveRates": [
                    490.12
                  ],
                  "paymentModel": "PAY_NOW",
                  "pointsBurn": 76186,
                  "pointsBurnCalculation": {
                    "code": "OMHZ",
                    "maximumLimit": 2147483647,
                    "minimumLimit": 1,
                    "scope": "DEFAULT",
                    "type": "RATE",
                    "value": 0.007
                  },
                  "strikethroughWithFees": 609.51,
                  "taxes": [],
                  "total": 533.3,
                  "totalFees": 101.47,
                  "totalInclusive": 533.3,
                  "totalStrikeThrough": 609.51,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          },
          {
            "amenities": [
              {
                "description": "Free self parking",
                "id": "2109"
              },
              {
                "description": "Free WiFi",
                "id": "2192"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 1,
                    "type": "KingBed"
                  }
                ],
                "bookToken": "hotel-expedia_b59c2b93c597445ea0f2d62ac64d019b_1783518136",
                "description": "1 King Bed",
                "id": "37321"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "AED",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308369",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 1586.1,
              "averageNightlyRateStrikethrough": 1866,
              "base": 1586.1,
              "baseStrikethrough": 1866,
              "currency": "AED",
              "fees": [
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "PROPERTY_FEE",
                  "value": 158.61
                },
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 214.12
                }
              ],
              "nightlyActualRates": [
                1586.1
              ],
              "nightlyInclusiveRates": [
                1800.22
              ],
              "paymentModel": "PAY_LATER",
              "strikethroughWithFees": 2238.73,
              "taxes": [],
              "total": 1958.83,
              "totalFees": 372.73,
              "totalInclusive": 1958.83,
              "totalStrikeThrough": 2238.73,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "AED",
                      "value": 1800.22
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 1586.1,
                  "averageNightlyRateStrikethrough": 1866,
                  "base": 1586.1,
                  "baseStrikethrough": 1866,
                  "currency": "AED",
                  "fees": [
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "PROPERTY_FEE",
                      "value": 158.61
                    },
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 214.12
                    }
                  ],
                  "nightlyActualRates": [
                    1586.1
                  ],
                  "nightlyInclusiveRates": [
                    1800.22
                  ],
                  "paymentModel": "PAY_LATER",
                  "strikethroughWithFees": 2238.73,
                  "taxes": [],
                  "total": 1958.83,
                  "totalFees": 372.73,
                  "totalInclusive": 1958.83,
                  "totalStrikeThrough": 2238.73,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          }
        ]
      },
      {
        "amenities": [
          {
            "description": "Hand-held showerhead",
            "id": "1073744651"
          },
          {
            "description": "Electric kettle",
            "id": "1073743289"
          },
          {
            "description": "Smooth flooring in room",
            "id": "1073745362"
          },
          {
            "description": "Soundproofed rooms",
            "id": "2054"
          },
          {
            "description": "Non-Smoking",
            "id": "6176"
          },
          {
            "description": "Phone",
            "id": "136"
          },
          {
            "description": "Toilet paper",
            "id": "1073744203"
          },
          {
            "description": "Espresso maker",
            "id": "399"
          },
          {
            "description": "Towels provided",
            "id": "1073743370"
          },
          {
            "description": "Bedsheets provided",
            "id": "1073743371"
          },
          {
            "description": "Air conditioning",
            "id": "1",
            "type": "air_conditioning"
          },
          {
            "description": "Visual fire alarm",
            "id": "1073744686"
          },
          {
            "description": "Private bathroom",
            "id": "141"
          },
          {
            "description": "Bathrobes",
            "id": "142"
          },
          {
            "description": "Housekeeping on request",
            "id": "1073743926"
          },
          {
            "description": "Free WiFi",
            "id": "2403",
            "type": "free_wifi"
          },
          {
            "description": "Free cribs/infant beds",
            "id": "4951",
            "type": "crib"
          },
          {
            "description": "Rollaway/extra beds (surcharge)",
            "id": "1073742816"
          },
          {
            "description": "Wireless internet access",
            "id": "2100"
          },
          {
            "description": "Grab bar - near toilet",
            "id": "1073744675"
          },
          {
            "description": "Bathroom emergency pull cord",
            "id": "1073744681"
          },
          {
            "description": "TV size measurement: inch",
            "id": "2580",
            "value": "inch"
          },
          {
            "description": "Satellite TV service",
            "id": "2396"
          },
          {
            "description": "TV size: 55",
            "id": "2579",
            "value": "55"
          },
          {
            "description": "Room service (24 hours)",
            "id": "2015"
          },
          {
            "description": "Slippers",
            "id": "2162"
          },
          {
            "description": "Minibar",
            "id": "131"
          },
          {
            "description": "WiFi speed - 100+ Mbps (good for 1–2 people or up to 6 devices)",
            "id": "1073745175",
            "value": "100+ Mbps (good for 1–2 people or up to 6 devices)"
          },
          {
            "description": "Iron/ironing board",
            "id": "145"
          },
          {
            "description": "In-room safe",
            "id": "146"
          },
          {
            "description": "Free bottled water",
            "id": "2057"
          },
          {
            "description": "Television",
            "id": "26"
          },
          {
            "description": "Free toiletries",
            "id": "143"
          },
          {
            "description": "Hair dryer",
            "id": "144"
          },
          {
            "description": "Coffee/tea maker",
            "id": "132"
          },
          {
            "description": "Rainfall showerhead",
            "id": "3502"
          },
          {
            "description": "Blackout drapes/curtains",
            "id": "2150"
          },
          {
            "description": "Bidet",
            "id": "2149"
          },
          {
            "description": "Laptop-friendly workspace",
            "id": "1073744237"
          },
          {
            "description": "LED TV",
            "id": "6147"
          },
          {
            "description": "Daily housekeeping",
            "id": "133"
          },
          {
            "description": "Shower/tub combination",
            "id": "2183"
          },
          {
            "description": "Desk",
            "id": "2026"
          },
          {
            "description": "Shampoo",
            "id": "1073744202"
          },
          {
            "description": "Wardrobe or closet",
            "id": "1073744706"
          },
          {
            "description": "Mobile key entry",
            "id": "1073744900"
          },
          {
            "description": "Soap",
            "id": "1073744201"
          },
          {
            "description": "Connecting/adjoining rooms available",
            "id": "4420"
          },
          {
            "description": "Desk chair",
            "id": "1073745166"
          },
          {
            "description": "Low-height counters/sink",
            "id": "1073744667"
          }
        ],
        "area": {
          "squareFeet": 377,
          "squareMeters": 35
        },
        "description": "<p><strong>1 King Bed</strong></p><p>377-sq-foot room with park views </p><br/><p><b>Internet</b> - Free WiFi 100+ Mbps (good for 1–2 people or up to 6 devices) </p><p><b>Entertainment</b> - 55-inch LED TV with satellite channels</p><p><b>Food & Drink</b> - Espresso maker, minibar (fees may apply), electric kettle, and 24-hour room service</p><p><b>Sleep</b> - Blackout drapes/curtains and bed sheets </p><p><b>Bathroom</b> - Private bathroom, bathrobes, and a shower/tub combination with a rainfall showerhead</p><p><b>Practical</b> - Safe, iron/ironing board, and laptop workspace; rollaway beds (surcharge) and cribs (free) available on request</p><p><b>Comfort</b> - Air conditioning and daily housekeeping</p><p><b>Accessibility</b> - Hand-held showerhead</p><p><b>Need to Know</b> - Housekeeping on request</p><p>Non-Smoking</p><p>Connecting/adjoining rooms can be requested, subject to availability </p>",
        "id": "315639070",
        "images": [
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/019367e3_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4128904e_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/010d268f_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e01f4810_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e96fc7a2_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c54d67f4_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/efbc732a_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
        ],
        "maxOccupancy": 4,
        "name": "Deluxe Room, 1 King Bed (Theme Park Access)",
        "propertyImages": [
          {
            "caption": "Living area",
            "isHero": true,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/019367e3_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/019367e3_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/019367e3_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/019367e3_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4128904e_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4128904e_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4128904e_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4128904e_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d41d21d2_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cd04ae58_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/010d268f_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/010d268f_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/010d268f_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/010d268f_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e01f4810_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e01f4810_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e01f4810_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e01f4810_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e96fc7a2_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e96fc7a2_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e96fc7a2_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/e96fc7a2_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c54d67f4_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c54d67f4_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c54d67f4_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c54d67f4_t.jpg"
          },
          {
            "caption": "Living area",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/efbc732a_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/efbc732a_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/efbc732a_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/efbc732a_t.jpg"
          },
          {
            "caption": "View from room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fab46c3b_t.jpg"
          },
          {
            "caption": "Bathroom shower",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
          }
        ],
        "rates": [
          {
            "amenities": [
              {
                "description": "Free WiFi",
                "id": "2192"
              },
              {
                "description": "Free self parking",
                "id": "2109"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 1,
                    "type": "KingBed"
                  }
                ],
                "bookToken": "hotel-expedia_b0a66725d9f04957b70285116d15b4c8_1783518136",
                "description": "1 King Bed",
                "id": "37321"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "USD",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308370",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 454.98,
              "averageNightlyRatePointsBurn": 64997,
              "averageNightlyRateStrikethrough": 535.27,
              "base": 454.98,
              "baseStrikethrough": 535.27,
              "currency": "USD",
              "fees": [
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "PROPERTY_FEE",
                  "value": 45.5
                },
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 61.42
                }
              ],
              "nightlyActualRates": [
                454.98
              ],
              "nightlyInclusiveRates": [
                516.4
              ],
              "paymentModel": "PAY_NOW",
              "pointsBurn": 80271,
              "pointsBurnCalculation": {
                "code": "OMHZ",
                "maximumLimit": 2147483647,
                "minimumLimit": 1,
                "scope": "DEFAULT",
                "type": "RATE",
                "value": 0.007
              },
              "strikethroughWithFees": 642.19,
              "taxes": [],
              "total": 561.9,
              "totalFees": 106.92,
              "totalInclusive": 561.9,
              "totalStrikeThrough": 642.19,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "USD",
                      "value": 516.4
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 454.98,
                  "averageNightlyRatePointsBurn": 64997,
                  "averageNightlyRateStrikethrough": 535.27,
                  "base": 454.98,
                  "baseStrikethrough": 535.27,
                  "currency": "USD",
                  "fees": [
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "PROPERTY_FEE",
                      "value": 45.5
                    },
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 61.42
                    }
                  ],
                  "nightlyActualRates": [
                    454.98
                  ],
                  "nightlyInclusiveRates": [
                    516.4
                  ],
                  "paymentModel": "PAY_NOW",
                  "pointsBurn": 80271,
                  "pointsBurnCalculation": {
                    "code": "OMHZ",
                    "maximumLimit": 2147483647,
                    "minimumLimit": 1,
                    "scope": "DEFAULT",
                    "type": "RATE",
                    "value": 0.007
                  },
                  "strikethroughWithFees": 642.19,
                  "taxes": [],
                  "total": 561.9,
                  "totalFees": 106.92,
                  "totalInclusive": 561.9,
                  "totalStrikeThrough": 642.19,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          },
          {
            "amenities": [
              {
                "description": "Free WiFi",
                "id": "2192"
              },
              {
                "description": "Free self parking",
                "id": "2109"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 1,
                    "type": "KingBed"
                  }
                ],
                "bookToken": "hotel-expedia_3c648161151349beba3f4ba6018525d3_1783518136",
                "description": "1 King Bed",
                "id": "37321"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "AED",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308370",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 1671.1,
              "averageNightlyRateStrikethrough": 1966,
              "base": 1671.1,
              "baseStrikethrough": 1966,
              "currency": "AED",
              "fees": [
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "PROPERTY_FEE",
                  "value": 167.11
                },
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 225.6
                }
              ],
              "nightlyActualRates": [
                1671.1
              ],
              "nightlyInclusiveRates": [
                1896.7
              ],
              "paymentModel": "PAY_LATER",
              "strikethroughWithFees": 2358.71,
              "taxes": [],
              "total": 2063.81,
              "totalFees": 392.71,
              "totalInclusive": 2063.81,
              "totalStrikeThrough": 2358.71,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "AED",
                      "value": 1896.7
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 1671.1,
                  "averageNightlyRateStrikethrough": 1966,
                  "base": 1671.1,
                  "baseStrikethrough": 1966,
                  "currency": "AED",
                  "fees": [
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "PROPERTY_FEE",
                      "value": 167.11
                    },
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 225.6
                    }
                  ],
                  "nightlyActualRates": [
                    1671.1
                  ],
                  "nightlyInclusiveRates": [
                    1896.7
                  ],
                  "paymentModel": "PAY_LATER",
                  "strikethroughWithFees": 2358.71,
                  "taxes": [],
                  "total": 2063.81,
                  "totalFees": 392.71,
                  "totalInclusive": 2063.81,
                  "totalStrikeThrough": 2358.71,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          }
        ]
      },
      {
        "amenities": [
          {
            "description": "Iron/ironing board",
            "id": "145"
          },
          {
            "description": "Smooth flooring in room",
            "id": "1073745362"
          },
          {
            "description": "Espresso maker",
            "id": "399"
          },
          {
            "description": "Free WiFi",
            "id": "2403",
            "type": "free_wifi"
          },
          {
            "description": "TV size: 55",
            "id": "2579",
            "value": "55"
          },
          {
            "description": "Wardrobe or closet",
            "id": "1073744706"
          },
          {
            "description": "Slippers",
            "id": "2162"
          },
          {
            "description": "Mobile key entry",
            "id": "1073744900"
          },
          {
            "description": "Coffee/tea maker",
            "id": "132"
          },
          {
            "description": "Wireless internet access",
            "id": "2100"
          },
          {
            "description": "Room service (24 hours)",
            "id": "2015"
          },
          {
            "description": "LED TV",
            "id": "6147"
          },
          {
            "description": "Desk",
            "id": "2026"
          },
          {
            "description": "Bidet",
            "id": "2149"
          },
          {
            "description": "Television",
            "id": "26"
          },
          {
            "description": "Rainfall showerhead",
            "id": "3502"
          },
          {
            "description": "Hand-held showerhead",
            "id": "1073744651"
          },
          {
            "description": "Free bottled water",
            "id": "2057"
          },
          {
            "description": "Bathroom emergency pull cord",
            "id": "1073744681"
          },
          {
            "description": "Visual fire alarm",
            "id": "1073744686"
          },
          {
            "description": "Soundproofed rooms",
            "id": "2054"
          },
          {
            "description": "Toilet paper",
            "id": "1073744203"
          },
          {
            "description": "Shower/tub combination",
            "id": "2183"
          },
          {
            "description": "Towels provided",
            "id": "1073743370"
          },
          {
            "description": "Free toiletries",
            "id": "143"
          },
          {
            "description": "Shampoo",
            "id": "1073744202"
          },
          {
            "description": "Satellite TV service",
            "id": "2396"
          },
          {
            "description": "Minibar",
            "id": "131"
          },
          {
            "description": "Private bathroom",
            "id": "141"
          },
          {
            "description": "TV size measurement: inch",
            "id": "2580",
            "value": "inch"
          },
          {
            "description": "Air conditioning",
            "id": "1",
            "type": "air_conditioning"
          },
          {
            "description": "Daily housekeeping",
            "id": "133"
          },
          {
            "description": "Housekeeping on request",
            "id": "1073743926"
          },
          {
            "description": "In-room safe",
            "id": "146"
          },
          {
            "description": "Free cribs/infant beds",
            "id": "4951",
            "type": "crib"
          },
          {
            "description": "Grab bar - near toilet",
            "id": "1073744675"
          },
          {
            "description": "Electric kettle",
            "id": "1073743289"
          },
          {
            "description": "Low-height counters/sink",
            "id": "1073744667"
          },
          {
            "description": "Blackout drapes/curtains",
            "id": "2150"
          },
          {
            "description": "Desk chair",
            "id": "1073745166"
          },
          {
            "description": "Rollaway/extra beds (surcharge)",
            "id": "1073742816"
          },
          {
            "description": "Connecting/adjoining rooms available",
            "id": "4420"
          },
          {
            "description": "Bedsheets provided",
            "id": "1073743371"
          },
          {
            "description": "Laptop-friendly workspace",
            "id": "1073744237"
          },
          {
            "description": "Soap",
            "id": "1073744201"
          },
          {
            "description": "Bathrobes",
            "id": "142"
          },
          {
            "description": "Phone",
            "id": "136"
          },
          {
            "description": "Hair dryer",
            "id": "144"
          },
          {
            "description": "Non-Smoking",
            "id": "6176"
          },
          {
            "description": "WiFi speed - 100+ Mbps (good for 1–2 people or up to 6 devices)",
            "id": "1073745175",
            "value": "100+ Mbps (good for 1–2 people or up to 6 devices)"
          }
        ],
        "area": {
          "squareFeet": 377,
          "squareMeters": 35
        },
        "description": "<p><strong>1 King Bed</strong></p><p>377-sq-foot room with pool views </p><br/><p><b>Layout</b> - Bedroom </p><p><b>Internet</b> - Free WiFi 100+ Mbps (good for 1–2 people or up to 6 devices) </p><p><b>Entertainment</b> - 55-inch LED TV with satellite channels</p><p><b>Food & Drink</b> - Espresso maker, minibar (fees may apply), electric kettle, and 24-hour room service</p><p><b>Sleep</b> - Blackout drapes/curtains and bed sheets </p><p><b>Bathroom</b> - Private bathroom, bathrobes, and a shower/tub combination with a rainfall showerhead</p><p><b>Practical</b> - Safe, iron/ironing board, and laptop workspace; rollaway beds (surcharge) and cribs (free) available on request</p><p><b>Comfort</b> - Air conditioning and daily housekeeping</p><p><b>Accessibility</b> - Hand-held showerhead</p><p><b>Need to Know</b> - Housekeeping on request</p><p>Non-Smoking</p><p>Connecting/adjoining rooms can be requested, subject to availability </p>",
        "id": "321424452",
        "images": [
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d8e83c67_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bc5beea4_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4b9e3802_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d06d78a7_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
        ],
        "maxOccupancy": 4,
        "name": "Artist Room, 1 King Bed, Pool View (Theme Park Access)",
        "propertyImages": [
          {
            "caption": "View from room",
            "isHero": true,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d8e83c67_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d8e83c67_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d8e83c67_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d8e83c67_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bc5beea4_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bc5beea4_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bc5beea4_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/bc5beea4_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4b9e3802_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4b9e3802_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4b9e3802_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4b9e3802_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_t.jpg"
          },
          {
            "caption": "Living area",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/8b6e209d_t.jpg"
          },
          {
            "caption": "Living area",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d06d78a7_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d06d78a7_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d06d78a7_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d06d78a7_t.jpg"
          },
          {
            "caption": "Bathroom shower",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_t.jpg"
          },
          {
            "caption": "Bathroom shower",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
          }
        ],
        "rates": [
          {
            "amenities": [
              {
                "description": "Free WiFi",
                "id": "2192"
              },
              {
                "description": "Free self parking",
                "id": "2109"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 1,
                    "type": "KingBed"
                  }
                ],
                "bookToken": "hotel-expedia_315b2ee83d214cc79ddcfe199fe977c6_1783518136",
                "description": "1 King Bed",
                "id": "37321"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "USD",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308375",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 466.55,
              "averageNightlyRatePointsBurn": 66650,
              "averageNightlyRateStrikethrough": 548.88,
              "base": 466.55,
              "baseStrikethrough": 548.88,
              "currency": "USD",
              "fees": [
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "PROPERTY_FEE",
                  "value": 46.66
                },
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 62.98
                }
              ],
              "nightlyActualRates": [
                466.55
              ],
              "nightlyInclusiveRates": [
                529.53
              ],
              "paymentModel": "PAY_NOW",
              "pointsBurn": 82313,
              "pointsBurnCalculation": {
                "code": "OMHZ",
                "maximumLimit": 2147483647,
                "minimumLimit": 1,
                "scope": "DEFAULT",
                "type": "RATE",
                "value": 0.007
              },
              "strikethroughWithFees": 658.52,
              "taxes": [],
              "total": 576.19,
              "totalFees": 109.64,
              "totalInclusive": 576.19,
              "totalStrikeThrough": 658.52,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "USD",
                      "value": 529.53
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 466.55,
                  "averageNightlyRatePointsBurn": 66650,
                  "averageNightlyRateStrikethrough": 548.88,
                  "base": 466.55,
                  "baseStrikethrough": 548.88,
                  "currency": "USD",
                  "fees": [
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "PROPERTY_FEE",
                      "value": 46.66
                    },
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 62.98
                    }
                  ],
                  "nightlyActualRates": [
                    466.55
                  ],
                  "nightlyInclusiveRates": [
                    529.53
                  ],
                  "paymentModel": "PAY_NOW",
                  "pointsBurn": 82313,
                  "pointsBurnCalculation": {
                    "code": "OMHZ",
                    "maximumLimit": 2147483647,
                    "minimumLimit": 1,
                    "scope": "DEFAULT",
                    "type": "RATE",
                    "value": 0.007
                  },
                  "strikethroughWithFees": 658.52,
                  "taxes": [],
                  "total": 576.19,
                  "totalFees": 109.64,
                  "totalInclusive": 576.19,
                  "totalStrikeThrough": 658.52,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          },
          {
            "amenities": [
              {
                "description": "Free self parking",
                "id": "2109"
              },
              {
                "description": "Free WiFi",
                "id": "2192"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 1,
                    "type": "KingBed"
                  }
                ],
                "bookToken": "hotel-expedia_8b78d4a653d34597b0d3098cd0af8709_1783518136",
                "description": "1 King Bed",
                "id": "37321"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "AED",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308375",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 1713.6,
              "averageNightlyRateStrikethrough": 2016,
              "base": 1713.6,
              "baseStrikethrough": 2016,
              "currency": "AED",
              "fees": [
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "PROPERTY_FEE",
                  "value": 171.36
                },
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 231.33
                }
              ],
              "nightlyActualRates": [
                1713.6
              ],
              "nightlyInclusiveRates": [
                1944.93
              ],
              "paymentModel": "PAY_LATER",
              "strikethroughWithFees": 2418.69,
              "taxes": [],
              "total": 2116.29,
              "totalFees": 402.69,
              "totalInclusive": 2116.29,
              "totalStrikeThrough": 2418.69,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "AED",
                      "value": 1944.93
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 1713.6,
                  "averageNightlyRateStrikethrough": 2016,
                  "base": 1713.6,
                  "baseStrikethrough": 2016,
                  "currency": "AED",
                  "fees": [
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "PROPERTY_FEE",
                      "value": 171.36
                    },
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 231.33
                    }
                  ],
                  "nightlyActualRates": [
                    1713.6
                  ],
                  "nightlyInclusiveRates": [
                    1944.93
                  ],
                  "paymentModel": "PAY_LATER",
                  "strikethroughWithFees": 2418.69,
                  "taxes": [],
                  "total": 2116.29,
                  "totalFees": 402.69,
                  "totalInclusive": 2116.29,
                  "totalStrikeThrough": 2418.69,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          }
        ]
      },
      {
        "amenities": [
          {
            "description": "Electric kettle",
            "id": "1073743289"
          },
          {
            "description": "Slippers",
            "id": "2162"
          },
          {
            "description": "Air conditioning",
            "id": "1",
            "type": "air_conditioning"
          },
          {
            "description": "Laptop-friendly workspace",
            "id": "1073744237"
          },
          {
            "description": "Satellite TV service",
            "id": "2396"
          },
          {
            "description": "TV size measurement: inch",
            "id": "2580",
            "value": "inch"
          },
          {
            "description": "Room service (24 hours)",
            "id": "2015"
          },
          {
            "description": "Desk chair",
            "id": "1073745166"
          },
          {
            "description": "Television",
            "id": "26"
          },
          {
            "description": "Shower/tub combination",
            "id": "2183"
          },
          {
            "description": "Towels provided",
            "id": "1073743370"
          },
          {
            "description": "Non-Smoking",
            "id": "6176"
          },
          {
            "description": "Blackout drapes/curtains",
            "id": "2150"
          },
          {
            "description": "Bidet",
            "id": "2149"
          },
          {
            "description": "Grab bar - near toilet",
            "id": "1073744675"
          },
          {
            "description": "Espresso maker",
            "id": "399"
          },
          {
            "description": "Rollaway/extra beds (surcharge)",
            "id": "1073742816"
          },
          {
            "description": "Bathroom emergency pull cord",
            "id": "1073744681"
          },
          {
            "description": "Connecting/adjoining rooms available",
            "id": "4420"
          },
          {
            "description": "Toilet paper",
            "id": "1073744203"
          },
          {
            "description": "Free WiFi",
            "id": "2403",
            "type": "free_wifi"
          },
          {
            "description": "Wardrobe or closet",
            "id": "1073744706"
          },
          {
            "description": "LED TV",
            "id": "6147"
          },
          {
            "description": "Wireless internet access",
            "id": "2100"
          },
          {
            "description": "Private bathroom",
            "id": "141"
          },
          {
            "description": "Hair dryer",
            "id": "144"
          },
          {
            "description": "Daily housekeeping",
            "id": "133"
          },
          {
            "description": "Housekeeping on request",
            "id": "1073743926"
          },
          {
            "description": "Bedsheets provided",
            "id": "1073743371"
          },
          {
            "description": "Bathrobes",
            "id": "142"
          },
          {
            "description": "Smooth flooring in room",
            "id": "1073745362"
          },
          {
            "description": "In-room safe",
            "id": "146"
          },
          {
            "description": "Free bottled water",
            "id": "2057"
          },
          {
            "description": "Phone",
            "id": "136"
          },
          {
            "description": "Soundproofed rooms",
            "id": "2054"
          },
          {
            "description": "Minibar",
            "id": "131"
          },
          {
            "description": "Hand-held showerhead",
            "id": "1073744651"
          },
          {
            "description": "Coffee/tea maker",
            "id": "132"
          },
          {
            "description": "Shampoo",
            "id": "1073744202"
          },
          {
            "description": "Low-height counters/sink",
            "id": "1073744667"
          },
          {
            "description": "Free cribs/infant beds",
            "id": "4951",
            "type": "crib"
          },
          {
            "description": "TV size: 55",
            "id": "2579",
            "value": "55"
          },
          {
            "description": "Desk",
            "id": "2026"
          },
          {
            "description": "Mobile key entry",
            "id": "1073744900"
          },
          {
            "description": "WiFi speed - 100+ Mbps (good for 1–2 people or up to 6 devices)",
            "id": "1073745175",
            "value": "100+ Mbps (good for 1–2 people or up to 6 devices)"
          },
          {
            "description": "Iron/ironing board",
            "id": "145"
          },
          {
            "description": "Rainfall showerhead",
            "id": "3502"
          },
          {
            "description": "Soap",
            "id": "1073744201"
          },
          {
            "description": "Free toiletries",
            "id": "143"
          },
          {
            "description": "Visual fire alarm",
            "id": "1073744686"
          }
        ],
        "area": {
          "squareFeet": 377,
          "squareMeters": 35
        },
        "description": "<p><strong>2 Double Beds</strong></p><p>377-sq-foot room with pool views </p><br/><p><b>Layout</b> - Bedroom </p><p><b>Internet</b> - Free WiFi 100+ Mbps (good for 1–2 people or up to 6 devices) </p><p><b>Entertainment</b> - 55-inch LED TV with satellite channels</p><p><b>Food & Drink</b> - Espresso maker, minibar (fees may apply), electric kettle, and 24-hour room service</p><p><b>Sleep</b> - Blackout drapes/curtains and bed sheets </p><p><b>Bathroom</b> - Private bathroom, bathrobes, and a shower/tub combination with a rainfall showerhead</p><p><b>Practical</b> - Safe, iron/ironing board, and laptop workspace; rollaway beds (surcharge) and cribs (free) available on request</p><p><b>Comfort</b> - Air conditioning and daily housekeeping</p><p><b>Accessibility</b> - Hand-held showerhead</p><p><b>Need to Know</b> - Housekeeping on request</p><p>Non-Smoking</p><p>Connecting/adjoining rooms can be requested, subject to availability </p>",
        "id": "321424458",
        "images": [
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
        ],
        "maxOccupancy": 3,
        "name": "Artist Room, 2 Double Beds, Pool View (Theme Park Access)",
        "propertyImages": [
          {
            "caption": "Living area",
            "isHero": true,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/dcbfea66_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/a3275171_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/51c52a06_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/fc0644c1_t.jpg"
          },
          {
            "caption": "View from room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0af24f1b_t.jpg"
          },
          {
            "caption": "View from room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/w3839h2558x0y0-af2727a8_t.jpg"
          },
          {
            "caption": "Bathroom shower",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_t.jpg"
          },
          {
            "caption": "Bathroom shower",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
          }
        ],
        "rates": [
          {
            "amenities": [
              {
                "description": "Free WiFi",
                "id": "2192"
              },
              {
                "description": "Free self parking",
                "id": "2109"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 2,
                    "type": "FullBed"
                  }
                ],
                "bookToken": "hotel-expedia_c89d58e008f041f3b797ca6593dafe4d_1783518136",
                "description": "2 Double Beds",
                "id": "37365"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "USD",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308376",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 466.55,
              "averageNightlyRatePointsBurn": 66650,
              "averageNightlyRateStrikethrough": 548.88,
              "base": 466.55,
              "baseStrikethrough": 548.88,
              "currency": "USD",
              "fees": [
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "PROPERTY_FEE",
                  "value": 46.66
                },
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 62.98
                }
              ],
              "nightlyActualRates": [
                466.55
              ],
              "nightlyInclusiveRates": [
                529.53
              ],
              "paymentModel": "PAY_NOW",
              "pointsBurn": 82313,
              "pointsBurnCalculation": {
                "code": "OMHZ",
                "maximumLimit": 2147483647,
                "minimumLimit": 1,
                "scope": "DEFAULT",
                "type": "RATE",
                "value": 0.007
              },
              "strikethroughWithFees": 658.52,
              "taxes": [],
              "total": 576.19,
              "totalFees": 109.64,
              "totalInclusive": 576.19,
              "totalStrikeThrough": 658.52,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "USD",
                      "value": 529.53
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 466.55,
                  "averageNightlyRatePointsBurn": 66650,
                  "averageNightlyRateStrikethrough": 548.88,
                  "base": 466.55,
                  "baseStrikethrough": 548.88,
                  "currency": "USD",
                  "fees": [
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "PROPERTY_FEE",
                      "value": 46.66
                    },
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 62.98
                    }
                  ],
                  "nightlyActualRates": [
                    466.55
                  ],
                  "nightlyInclusiveRates": [
                    529.53
                  ],
                  "paymentModel": "PAY_NOW",
                  "pointsBurn": 82313,
                  "pointsBurnCalculation": {
                    "code": "OMHZ",
                    "maximumLimit": 2147483647,
                    "minimumLimit": 1,
                    "scope": "DEFAULT",
                    "type": "RATE",
                    "value": 0.007
                  },
                  "strikethroughWithFees": 658.52,
                  "taxes": [],
                  "total": 576.19,
                  "totalFees": 109.64,
                  "totalInclusive": 576.19,
                  "totalStrikeThrough": 658.52,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          },
          {
            "amenities": [
              {
                "description": "Free WiFi",
                "id": "2192"
              },
              {
                "description": "Free self parking",
                "id": "2109"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 2,
                    "type": "FullBed"
                  }
                ],
                "bookToken": "hotel-expedia_cffef8e6d35340f98deda574ee08a301_1783518136",
                "description": "2 Double Beds",
                "id": "37365"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "AED",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308376",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 1713.6,
              "averageNightlyRateStrikethrough": 2016,
              "base": 1713.6,
              "baseStrikethrough": 2016,
              "currency": "AED",
              "fees": [
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "PROPERTY_FEE",
                  "value": 171.36
                },
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 231.33
                }
              ],
              "nightlyActualRates": [
                1713.6
              ],
              "nightlyInclusiveRates": [
                1944.93
              ],
              "paymentModel": "PAY_LATER",
              "strikethroughWithFees": 2418.69,
              "taxes": [],
              "total": 2116.29,
              "totalFees": 402.69,
              "totalInclusive": 2116.29,
              "totalStrikeThrough": 2418.69,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "AED",
                      "value": 1944.93
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 1713.6,
                  "averageNightlyRateStrikethrough": 2016,
                  "base": 1713.6,
                  "baseStrikethrough": 2016,
                  "currency": "AED",
                  "fees": [
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "PROPERTY_FEE",
                      "value": 171.36
                    },
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 231.33
                    }
                  ],
                  "nightlyActualRates": [
                    1713.6
                  ],
                  "nightlyInclusiveRates": [
                    1944.93
                  ],
                  "paymentModel": "PAY_LATER",
                  "strikethroughWithFees": 2418.69,
                  "taxes": [],
                  "total": 2116.29,
                  "totalFees": 402.69,
                  "totalInclusive": 2116.29,
                  "totalStrikeThrough": 2418.69,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          }
        ]
      },
      {
        "amenities": [
          {
            "description": "Housekeeping on request",
            "id": "1073743926"
          },
          {
            "description": "Smooth flooring in room",
            "id": "1073745362"
          },
          {
            "description": "Free bottled water",
            "id": "2057"
          },
          {
            "description": "Blackout drapes/curtains",
            "id": "2150"
          },
          {
            "description": "Bathroom emergency pull cord",
            "id": "1073744681"
          },
          {
            "description": "Satellite TV service",
            "id": "2396"
          },
          {
            "description": "Television",
            "id": "26"
          },
          {
            "description": "Grab bar - near toilet",
            "id": "1073744675"
          },
          {
            "description": "Hand-held showerhead",
            "id": "1073744651"
          },
          {
            "description": "Laptop-friendly workspace",
            "id": "1073744237"
          },
          {
            "description": "Minibar",
            "id": "131"
          },
          {
            "description": "Coffee/tea maker",
            "id": "132"
          },
          {
            "description": "Desk",
            "id": "2026"
          },
          {
            "description": "Private bathroom",
            "id": "141"
          },
          {
            "description": "Toilet paper",
            "id": "1073744203"
          },
          {
            "description": "Desk chair",
            "id": "1073745166"
          },
          {
            "description": "Air conditioning",
            "id": "1",
            "type": "air_conditioning"
          },
          {
            "description": "Low-height counters/sink",
            "id": "1073744667"
          },
          {
            "description": "In-room safe",
            "id": "146"
          },
          {
            "description": "Electric kettle",
            "id": "1073743289"
          },
          {
            "description": "Bathrobes",
            "id": "142"
          },
          {
            "description": "Hair dryer",
            "id": "144"
          },
          {
            "description": "WiFi speed - 100+ Mbps (good for 1–2 people or up to 6 devices)",
            "id": "1073745175",
            "value": "100+ Mbps (good for 1–2 people or up to 6 devices)"
          },
          {
            "description": "Soap",
            "id": "1073744201"
          },
          {
            "description": "Daily housekeeping",
            "id": "133"
          },
          {
            "description": "Slippers",
            "id": "2162"
          },
          {
            "description": "Connecting/adjoining rooms available",
            "id": "4420"
          },
          {
            "description": "Towels provided",
            "id": "1073743370"
          },
          {
            "description": "Bedsheets provided",
            "id": "1073743371"
          },
          {
            "description": "Phone",
            "id": "136"
          },
          {
            "description": "Shampoo",
            "id": "1073744202"
          },
          {
            "description": "LED TV",
            "id": "6147"
          },
          {
            "description": "Wardrobe or closet",
            "id": "1073744706"
          },
          {
            "description": "Rollaway/extra beds (surcharge)",
            "id": "1073742816"
          },
          {
            "description": "Wireless internet access",
            "id": "2100"
          },
          {
            "description": "Non-Smoking",
            "id": "6176"
          },
          {
            "description": "TV size measurement: inch",
            "id": "2580",
            "value": "inch"
          },
          {
            "description": "Mobile key entry",
            "id": "1073744900"
          },
          {
            "description": "Free toiletries",
            "id": "143"
          },
          {
            "description": "Soundproofed rooms",
            "id": "2054"
          },
          {
            "description": "Iron/ironing board",
            "id": "145"
          },
          {
            "description": "TV size: 55",
            "id": "2579",
            "value": "55"
          },
          {
            "description": "Visual fire alarm",
            "id": "1073744686"
          },
          {
            "description": "Espresso maker",
            "id": "399"
          },
          {
            "description": "Free WiFi",
            "id": "2403",
            "type": "free_wifi"
          },
          {
            "description": "Bidet",
            "id": "2149"
          },
          {
            "description": "Rainfall showerhead",
            "id": "3502"
          },
          {
            "description": "Room service (24 hours)",
            "id": "2015"
          },
          {
            "description": "Free cribs/infant beds",
            "id": "4951",
            "type": "crib"
          },
          {
            "description": "Shower/tub combination",
            "id": "2183"
          }
        ],
        "area": {
          "squareFeet": 377,
          "squareMeters": 35
        },
        "description": "<p><strong>1 King Bed and 1 Twin Bunk Bed</strong></p><p>377 sq feet </p><br/><p><b>Layout</b> - Bedroom </p><p><b>Internet</b> - Free WiFi 100+ Mbps (good for 1–2 people or up to 6 devices) </p><p><b>Entertainment</b> - 55-inch LED TV with satellite channels</p><p><b>Food & Drink</b> - Espresso maker, minibar (fees may apply), electric kettle, and 24-hour room service</p><p><b>Sleep</b> - Blackout drapes/curtains and bed sheets </p><p><b>Bathroom</b> - Private bathroom, bathrobes, and a shower/tub combination with a rainfall showerhead</p><p><b>Practical</b> - Safe, iron/ironing board, and laptop workspace; rollaway beds (surcharge) and cribs (free) available on request</p><p><b>Comfort</b> - Air conditioning and daily housekeeping</p><p><b>Accessibility</b> - Hand-held showerhead</p><p><b>Need to Know</b> - Housekeeping on request</p><p>Non-Smoking</p><p>Connecting/adjoining rooms can be requested, subject to availability </p>",
        "id": "321890456",
        "images": [
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
        ],
        "maxOccupancy": 4,
        "name": "King Artist Room With Kids Bunk Bed (Theme Park Access)",
        "propertyImages": [
          {
            "caption": "Room",
            "isHero": true,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/cce6f515_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/3e936972_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0e47ee69_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/0ff4b55b_t.jpg"
          },
          {
            "caption": "Living area",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d2f568d7_t.jpg"
          },
          {
            "caption": "Living area",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c3fd0880_t.jpg"
          },
          {
            "caption": "Living area",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/17d82ede_t.jpg"
          },
          {
            "caption": "Bathroom shower",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/4749936a_t.jpg"
          },
          {
            "caption": "Bathroom shower",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
          }
        ],
        "rates": [
          {
            "amenities": [
              {
                "description": "Free WiFi",
                "id": "2192"
              },
              {
                "description": "Free self parking",
                "id": "2109"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 1,
                    "type": "KingBed"
                  },
                  {
                    "count": 1,
                    "type": "BunkBed"
                  }
                ],
                "bookToken": "hotel-expedia_566213e226dd428092dbf38a84c08ea5_1783518136",
                "description": "1 King Bed and 1 Twin Bunk Bed",
                "id": "38121"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "USD",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308377",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 535.98,
              "averageNightlyRatePointsBurn": 76569,
              "averageNightlyRateStrikethrough": 630.56,
              "base": 535.98,
              "baseStrikethrough": 630.56,
              "currency": "USD",
              "fees": [
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "PROPERTY_FEE",
                  "value": 53.6
                },
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 72.36
                }
              ],
              "nightlyActualRates": [
                535.98
              ],
              "nightlyInclusiveRates": [
                608.34
              ],
              "paymentModel": "PAY_NOW",
              "pointsBurn": 94563,
              "pointsBurnCalculation": {
                "code": "OMHZ",
                "maximumLimit": 2147483647,
                "minimumLimit": 1,
                "scope": "DEFAULT",
                "type": "RATE",
                "value": 0.007
              },
              "strikethroughWithFees": 756.52,
              "taxes": [],
              "total": 661.94,
              "totalFees": 125.96,
              "totalInclusive": 661.94,
              "totalStrikeThrough": 756.52,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "USD",
                      "value": 608.34
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 535.98,
                  "averageNightlyRatePointsBurn": 76569,
                  "averageNightlyRateStrikethrough": 630.56,
                  "base": 535.98,
                  "baseStrikethrough": 630.56,
                  "currency": "USD",
                  "fees": [
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "PROPERTY_FEE",
                      "value": 53.6
                    },
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 72.36
                    }
                  ],
                  "nightlyActualRates": [
                    535.98
                  ],
                  "nightlyInclusiveRates": [
                    608.34
                  ],
                  "paymentModel": "PAY_NOW",
                  "pointsBurn": 94563,
                  "pointsBurnCalculation": {
                    "code": "OMHZ",
                    "maximumLimit": 2147483647,
                    "minimumLimit": 1,
                    "scope": "DEFAULT",
                    "type": "RATE",
                    "value": 0.007
                  },
                  "strikethroughWithFees": 756.52,
                  "taxes": [],
                  "total": 661.94,
                  "totalFees": 125.96,
                  "totalInclusive": 661.94,
                  "totalStrikeThrough": 756.52,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          },
          {
            "amenities": [
              {
                "description": "Free WiFi",
                "id": "2192"
              },
              {
                "description": "Free self parking",
                "id": "2109"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 1,
                    "type": "KingBed"
                  },
                  {
                    "count": 1,
                    "type": "BunkBed"
                  }
                ],
                "bookToken": "hotel-expedia_5782d8bb5baa4f0cb983af842ae73ba5_1783518136",
                "description": "1 King Bed and 1 Twin Bunk Bed",
                "id": "38121"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "AED",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308377",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 1968.6,
              "averageNightlyRateStrikethrough": 2316,
              "base": 1968.6,
              "baseStrikethrough": 2316,
              "currency": "AED",
              "fees": [
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "PROPERTY_FEE",
                  "value": 196.86
                },
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 265.75
                }
              ],
              "nightlyActualRates": [
                1968.6
              ],
              "nightlyInclusiveRates": [
                2234.35
              ],
              "paymentModel": "PAY_LATER",
              "strikethroughWithFees": 2778.61,
              "taxes": [],
              "total": 2431.21,
              "totalFees": 462.61,
              "totalInclusive": 2431.21,
              "totalStrikeThrough": 2778.61,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "AED",
                      "value": 2234.35
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 1968.6,
                  "averageNightlyRateStrikethrough": 2316,
                  "base": 1968.6,
                  "baseStrikethrough": 2316,
                  "currency": "AED",
                  "fees": [
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "PROPERTY_FEE",
                      "value": 196.86
                    },
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 265.75
                    }
                  ],
                  "nightlyActualRates": [
                    1968.6
                  ],
                  "nightlyInclusiveRates": [
                    2234.35
                  ],
                  "paymentModel": "PAY_LATER",
                  "strikethroughWithFees": 2778.61,
                  "taxes": [],
                  "total": 2431.21,
                  "totalFees": 462.61,
                  "totalInclusive": 2431.21,
                  "totalStrikeThrough": 2778.61,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          }
        ]
      },
      {
        "amenities": [
          {
            "description": "WiFi speed - 100+ Mbps (good for 1–2 people or up to 6 devices)",
            "id": "1073745175",
            "value": "100+ Mbps (good for 1–2 people or up to 6 devices)"
          },
          {
            "description": "Toilet paper",
            "id": "1073744203"
          },
          {
            "description": "Free WiFi",
            "id": "2403",
            "type": "free_wifi"
          },
          {
            "description": "Phone",
            "id": "136"
          },
          {
            "description": "Private bathroom",
            "id": "141"
          },
          {
            "description": "Room service (24 hours)",
            "id": "2015"
          },
          {
            "description": "TV size: 55",
            "id": "2579",
            "value": "55"
          },
          {
            "description": "Blackout drapes/curtains",
            "id": "2150"
          },
          {
            "description": "Hand-held showerhead",
            "id": "1073744651"
          },
          {
            "description": "Towels provided",
            "id": "1073743370"
          },
          {
            "description": "Minibar",
            "id": "131"
          },
          {
            "description": "Desk chair",
            "id": "1073745166"
          },
          {
            "description": "Housekeeping on request",
            "id": "1073743926"
          },
          {
            "description": "Balcony",
            "id": "318"
          },
          {
            "description": "Free toiletries",
            "id": "143"
          },
          {
            "description": "Rainfall showerhead",
            "id": "3502"
          },
          {
            "description": "TV size measurement: inch",
            "id": "2580",
            "value": "inch"
          },
          {
            "description": "Soap",
            "id": "1073744201"
          },
          {
            "description": "Rollaway/extra beds (surcharge)",
            "id": "1073742816"
          },
          {
            "description": "Air conditioning",
            "id": "1",
            "type": "air_conditioning"
          },
          {
            "description": "Free bottled water",
            "id": "2057"
          },
          {
            "description": "Espresso maker",
            "id": "399"
          },
          {
            "description": "Low-height counters/sink",
            "id": "1073744667"
          },
          {
            "description": "Television",
            "id": "26"
          },
          {
            "description": "Free cribs/infant beds",
            "id": "4951",
            "type": "crib"
          },
          {
            "description": "Wireless internet access",
            "id": "2100"
          },
          {
            "description": "Desk",
            "id": "2026"
          },
          {
            "description": "Electric kettle",
            "id": "1073743289"
          },
          {
            "description": "Smooth flooring in room",
            "id": "1073745362"
          },
          {
            "description": "Bathroom emergency pull cord",
            "id": "1073744681"
          },
          {
            "description": "Daily housekeeping",
            "id": "133"
          },
          {
            "description": "Mobile key entry",
            "id": "1073744900"
          },
          {
            "description": "Connecting/adjoining rooms available",
            "id": "4420"
          },
          {
            "description": "In-room safe",
            "id": "146"
          },
          {
            "description": "Shower/tub combination",
            "id": "2183"
          },
          {
            "description": "Visual fire alarm",
            "id": "1073744686"
          },
          {
            "description": "Bathrobes",
            "id": "142"
          },
          {
            "description": "Hair dryer",
            "id": "144"
          },
          {
            "description": "Iron/ironing board",
            "id": "145"
          },
          {
            "description": "Bedsheets provided",
            "id": "1073743371"
          },
          {
            "description": "Soundproofed rooms",
            "id": "2054"
          },
          {
            "description": "Shampoo",
            "id": "1073744202"
          },
          {
            "description": "Non-Smoking",
            "id": "6176"
          },
          {
            "description": "Laptop-friendly workspace",
            "id": "1073744237"
          },
          {
            "description": "Wardrobe or closet",
            "id": "1073744706"
          },
          {
            "description": "Bidet",
            "id": "2149"
          },
          {
            "description": "Slippers",
            "id": "2162"
          },
          {
            "description": "Coffee/tea maker",
            "id": "132"
          },
          {
            "description": "Satellite TV service",
            "id": "2396"
          },
          {
            "description": "Grab bar - near toilet",
            "id": "1073744675"
          },
          {
            "description": "LED TV",
            "id": "6147"
          }
        ],
        "area": {
          "squareFeet": 581,
          "squareMeters": 54
        },
        "description": "<p><strong>1 King Bed</strong></p><p>581-sq-foot soundproofed room, balcony with park views </p><br/><p><b>Internet</b> - Free WiFi 100+ Mbps (good for 1–2 people or up to 6 devices) </p><p><b>Entertainment</b> - 55-inch LED TV with satellite channels</p><p><b>Food & Drink</b> - Espresso maker, minibar (fees may apply), electric kettle, and 24-hour room service</p><p><b>Sleep</b> - Blackout drapes/curtains and bed sheets </p><p><b>Bathroom</b> - 2 bathrooms, bathrobes, and a shower/tub combination with a rainfall showerhead</p><p><b>Practical</b> - Safe, iron/ironing board, and laptop workspace; rollaway beds (surcharge) and cribs (free) available on request</p><p><b>Comfort</b> - Air conditioning and daily housekeeping</p><p><b>Accessibility</b> - Hand-held showerhead</p><p><b>Need to Know</b> - Housekeeping on request</p><p>Non-Smoking</p><p>Connecting/adjoining rooms can be requested, subject to availability </p>",
        "id": "315639073",
        "images": [
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_z.jpg",
          "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg"
        ],
        "maxOccupancy": 4,
        "name": "Suite, 1 King Bed, Balcony, Corner (Theme Park Access)",
        "propertyImages": [
          {
            "caption": "Room",
            "isHero": true,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/196a39e6_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/08e13577_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/52ac0814_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/054399ec_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/77d42506_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/b6b62b71_t.jpg"
          },
          {
            "caption": "Room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c240df03_t.jpg"
          },
          {
            "caption": "View from room",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/d595a2ee_t.jpg"
          },
          {
            "caption": "Bathroom",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/21dc0f48_t.jpg"
          },
          {
            "caption": "Bathroom shower",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/785a0f0f_t.jpg"
          },
          {
            "caption": "Bathroom shower",
            "isHero": false,
            "large": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_z.jpg",
            "medium": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_b.jpg",
            "small": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_s.jpg",
            "thumbnail": "https://i.travelapi.com/lodging/72000000/71560000/71554900/71554879/c38477b9_t.jpg"
          }
        ],
        "rates": [
          {
            "amenities": [
              {
                "description": "Free WiFi",
                "id": "2192"
              },
              {
                "description": "Free self parking",
                "id": "2109"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 1,
                    "type": "KingBed"
                  }
                ],
                "bookToken": "hotel-expedia_e2ae92cb06a1444091c6178af0aafe5e_1783518136",
                "description": "1 King Bed",
                "id": "37321"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "USD",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308371",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 628.55,
              "averageNightlyRatePointsBurn": 89793,
              "averageNightlyRateStrikethrough": 739.47,
              "base": 628.55,
              "baseStrikethrough": 739.47,
              "currency": "USD",
              "fees": [
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "PROPERTY_FEE",
                  "value": 62.85
                },
                {
                  "currency": "USD",
                  "isIncluded": true,
                  "payLocally": false,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 84.85
                }
              ],
              "nightlyActualRates": [
                628.55
              ],
              "nightlyInclusiveRates": [
                713.4
              ],
              "paymentModel": "PAY_NOW",
              "pointsBurn": 110893,
              "pointsBurnCalculation": {
                "code": "OMHZ",
                "maximumLimit": 2147483647,
                "minimumLimit": 1,
                "scope": "DEFAULT",
                "type": "RATE",
                "value": 0.007
              },
              "strikethroughWithFees": 887.17,
              "taxes": [],
              "total": 776.25,
              "totalFees": 147.7,
              "totalInclusive": 776.25,
              "totalStrikeThrough": 887.17,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "USD",
                      "value": 713.4
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 628.55,
                  "averageNightlyRatePointsBurn": 89793,
                  "averageNightlyRateStrikethrough": 739.47,
                  "base": 628.55,
                  "baseStrikethrough": 739.47,
                  "currency": "USD",
                  "fees": [
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "PROPERTY_FEE",
                      "value": 62.85
                    },
                    {
                      "currency": "USD",
                      "isIncluded": true,
                      "payLocally": false,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 84.85
                    }
                  ],
                  "nightlyActualRates": [
                    628.55
                  ],
                  "nightlyInclusiveRates": [
                    713.4
                  ],
                  "paymentModel": "PAY_NOW",
                  "pointsBurn": 110893,
                  "pointsBurnCalculation": {
                    "code": "OMHZ",
                    "maximumLimit": 2147483647,
                    "minimumLimit": 1,
                    "scope": "DEFAULT",
                    "type": "RATE",
                    "value": 0.007
                  },
                  "strikethroughWithFees": 887.17,
                  "taxes": [],
                  "total": 776.25,
                  "totalFees": 147.7,
                  "totalInclusive": 776.25,
                  "totalStrikeThrough": 887.17,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          },
          {
            "amenities": [
              {
                "description": "Free self parking",
                "id": "2109"
              },
              {
                "description": "Free WiFi",
                "id": "2192"
              }
            ],
            "available": 9,
            "bedGroups": [
              {
                "beds": [
                  {
                    "count": 1,
                    "type": "KingBed"
                  }
                ],
                "bookToken": "hotel-expedia_4522672a9165418ba4f1dad6bcbe0353_1783518136",
                "description": "1 King Bed",
                "id": "37321"
              }
            ],
            "cancelPenalties": [
              {
                "currency": "AED",
                "end": "2026-12-13T23:59:00+04:00",
                "nights": 1,
                "percent": 100,
                "start": "2026-12-12T23:59:00+04:00"
              }
            ],
            "id": "409308371",
            "isBreakfastIncluded": false,
            "isFoodBeverageCredit": false,
            "isFreeCancellation": true,
            "isParkingIncluded": true,
            "isShuttleIncluded": false,
            "memberOnlyDeal": false,
            "pricingInfo": {
              "averageNightlyRate": 2308.6,
              "averageNightlyRateStrikethrough": 2716,
              "base": 2308.6,
              "baseStrikethrough": 2716,
              "currency": "AED",
              "fees": [
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "PROPERTY_FEE",
                  "value": 230.86
                },
                {
                  "currency": "AED",
                  "isIncluded": true,
                  "payLocally": true,
                  "type": "TAX_AND_SERVICE_FEE",
                  "value": 311.65
                }
              ],
              "nightlyActualRates": [
                2308.6
              ],
              "nightlyInclusiveRates": [
                2620.25
              ],
              "paymentModel": "PAY_LATER",
              "strikethroughWithFees": 3258.51,
              "taxes": [],
              "total": 2851.11,
              "totalFees": 542.51,
              "totalInclusive": 2851.11,
              "totalStrikeThrough": 3258.51,
              "totalTaxes": 0
            },
            "rooms": [
              {
                "adults": 2,
                "cancellationPolicies": [
                  {
                    "applicability": "BEFORE_CHECK_IN",
                    "beginQuantity": 15,
                    "cancellationFee": {
                      "currency": "AED",
                      "value": 2620.25
                    },
                    "endQuantity": -8,
                    "freeCancellationEndDateTime": "2026-12-12T23:59:00+04:00",
                    "text": "We understand that plans may change, and we aim to be as transparent as possible with our cancellation terms:\n\t- Refundable: Yes\nCancellation Penalty Window:\n\t- If you cancel between December 12, 2026, 23:59 UTC+04 (property local time) and December 13, 2026, 23:59 UTC+04 (property local time), a 1 night cancellation fee will apply to the total reservation amount.",
                    "unit": "HOUR"
                  }
                ],
                "id": "ZROOM-EXPEDIA-0",
                "pricingInfo": {
                  "averageNightlyRate": 2308.6,
                  "averageNightlyRateStrikethrough": 2716,
                  "base": 2308.6,
                  "baseStrikethrough": 2716,
                  "currency": "AED",
                  "fees": [
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "PROPERTY_FEE",
                      "value": 230.86
                    },
                    {
                      "currency": "AED",
                      "isIncluded": true,
                      "payLocally": true,
                      "type": "TAX_AND_SERVICE_FEE",
                      "value": 311.65
                    }
                  ],
                  "nightlyActualRates": [
                    2308.6
                  ],
                  "nightlyInclusiveRates": [
                    2620.25
                  ],
                  "paymentModel": "PAY_LATER",
                  "strikethroughWithFees": 3258.51,
                  "taxes": [],
                  "total": 2851.11,
                  "totalFees": 542.51,
                  "totalInclusive": 2851.11,
                  "totalStrikeThrough": 3258.51,
                  "totalTaxes": 0
                }
              }
            ],
            "supplierRatePromotion": {
              "description": "Save 15%",
              "supplierId": "863145816"
            }
          }
        ]
      }
    ],
    "starRating": "0.0",
    "supplierCode": "EXPEDIA",
    "supplierFeesDescriptions": [
      {
        "isRequired": false,
        "text": "Fee for buffet breakfast: approximately AED 120.00 for adults and AED 60 for children"
      },
      {
        "isRequired": false,
        "text": "Rollaway bed fee: AED 150.0 per night"
      }
    ],
    "supplierId": "71554879",
    "type": "Resort",
    "userReviews": {
      "availableReviewCount": 5,
      "rating": "4.9",
      "ratingImageUrl": "https://static.tacdn.com/img/cdsi/img2/ratings/traveler/5.0-19891-5.svg",
      "reviewCount": 2839
    }
  }
};
